// index.js - Main entry point v4 - Integrated UIController, Updated Ribbon
console.log('🔍 TRACE: index.js execution started');
console.log('🔍 TRACE: PROJECT_VERSION from webpack:', typeof PROJECT_VERSION !== 'undefined' ? PROJECT_VERSION : 'UNDEFINED');

import '../public/enhanced-styles.css'; // Load CSS for UI FIRST
console.log('🔍 TRACE: CSS imported successfully');
import Phaser from 'phaser';
console.log('🔍 TRACE: Phaser imported successfully');

import RexUIPlugin from 'phaser3-rex-plugins/templates/ui/ui-plugin.js';
console.log('🔍 TRACE: RexUI imported successfully');

// Vercel Analytics - Initialize immediately
import { inject } from '@vercel/analytics';
import { injectSpeedInsights } from '@vercel/speed-insights';
console.log('🔍 TRACE: Vercel analytics imported successfully');

// Initialize Vercel Analytics
inject();
injectSpeedInsights();
console.log('🔍 TRACE: Vercel analytics initialized successfully');


import BootSceneDOM from "./scenes/BootSceneDOM.js";
import MainMenuScene from './scenes/MainMenuScene.js';
import MainMenuSceneDOM from './scenes/MainMenuSceneDOM.js';
import GuestMenuScene from './scenes/GuestMenuScene.js';
import GuestMenuSceneDOM from './scenes/GuestMenuSceneDOM.js';
import AuthenticatedMenuScene from "./scenes/AuthenticatedMenuScene.js";
import AuthenticatedMenuSceneDOM from "./scenes/AuthenticatedMenuSceneDOM.js";
import MainMenuSceneUniversal from "./scenes/MainMenuSceneUniversal.js";
import ProfileScene from "./scenes/ProfileScene.js";
import ProfileSceneDOM from "./scenes/ProfileSceneDOM.js";
import PPTHeroScene from "./scenes/PPTHeroScene.js";
// New modular PPT Hero scenes
import PPTHeroGenericScene from "./scenes/ppt-hero/firms/PPTHeroGenericScene.js";
import PPTHeroBainScene from "./scenes/ppt-hero/firms/PPTHeroBainScene.js";
import GameScene from "./scenes/GameScene.js"; // Slide Wars single player
import MultiplayerMenuScene from "./scenes/MultiplayerMenuScene.js";
import CreateGameScene from "./scenes/CreateGameScene.js";
import JoinGameScene from "./scenes/JoinGameScene.js";
import ProfileLoadingScene from './scenes/ProfileLoadingScene.js';
import LobbyScene from "./scenes/LobbyScene.js";
import MultiplayerGameScene from "./scenes/MultiplayerGameScene.js";
import AdminConsoleScene from "./scenes/AdminConsoleScene.js";
import MultiplayerGameOverScene from './scenes/MultiplayerGameOverScene.js'; // Make sure this is correct path
import { showGeneralMessage } from './ui/uiUtils.js';
import { auth, db } from './firebaseConfig.js'; // Firebase
import MobileOfflineManager from './services/MobileOfflineManager.js'; // Offline support
import MobileAnalytics from './services/MobileAnalytics.js'; // Mobile analytics
import UnifiedMobileSystem from './services/UnifiedMobileSystem.js'; // Unified mobile system (replaces all others)
import { MobileArchitectureValidator } from './tests/MobileArchitectureValidator.js'; // Comprehensive testing
import { UserScopedStorage } from './services/UserScopedStorage.js'; // User-scoped localStorage
import { DesktopAuthProtection } from './services/DesktopAuthProtection.js'; // Desktop auth protection
import ZIndexManager from './utils/ZIndexManager.js'; // Z-index management
import sessionManager from './services/SessionManager.js'; // Session Tracking
import sceneManager from './utils/SceneManager.js';
import './utils/TemplateOverlayManager.js'; // Template overlay management
import './utils/ToastManager.js'; // Enterprise toast notifications
import './utils/SessionTimeoutManager.js'; // Enterprise session security
import './utils/CompanyLookupService.js'; // Company email domain mapping
import './utils/NativeIntegrationManager.js'; // Enterprise native mobile integration
import './utils/ErrorStateManager.js'; // Enterprise error state management
import MenuRouting from './utils/MenuRouting.js'; // Menu routing service
import CanvasFixer from './canvasFixer.js'; // Canvas rendering fixes
import cookieManager from './utils/cookieManager.js'; // Cookie Consent
import UIController from './ui/uiController.js'; // Central UI Manager (Imported before usage)
import { populateAnalyticsOverlay } from './ui/analyticsUI.js'; // Analytics Content
// Import setupAuthEventListeners from authUI
import { setupAuthEventListeners, showAuthOverlay } from './ui/authUI.js'; // For auth setup
import './ui/AuthenticationDialogs_CLEAN.js'; // Clean professional authentication dialogs with exact template CSS
import './services/EmailTemplateService.js'; // Professional email templates
import './services/PasswordResetService.js'; // Password reset functionality
// ENTERPRISE REFACTOR: Import enterprise services for unified architecture
import enterpriseAuthService from './services/EnterpriseAuthService.js'; // Unified authentication
import desktopStyleManager from './services/DesktopStyleManager.js'; // Desktop CSS protection
import mobileStyleManager from './services/MobileStyleManager.js'; // Mobile CSS optimization (SEPARATE from UnifiedMobileSystem)
import enterpriseSceneManager from './services/EnterpriseSceneManager.js'; // Scene presentation architecture (SEPARATE from MobileDesktopRouter)
import enterpriseRefactorIntegration from './utils/EnterpriseRefactorIntegration.js'; // Integration helper
import { signOutUser, claimAnonymousScores } from './services/authService.js'; // Auth Service
import { hasSpecialAccess, getSpecialAccessHoursRemaining, getSpecialAccessDisplayName} from './services/specialAccessService.js';
import { checkSpecialAccessOnStartup } from './utils/accessChecker.js';
import NavigationManager from './ui/NavigationManager.js'; // Responsive navigation
import UIUpgradeManager from './ui/UIUpgradeManager.js'; // Safe UI migration system
import PhilosophyFlowScene from './scenes/PhilosophyFlowScene.js';
import ClassifyScene from './scenes/ClassifyScene.js';
import ClassifyTechGameOverScene from './scenes/ClassifyTechGameOverScene.js';

console.log('🔍 TRACE: About to define mobile detection...');

// REMOVED: Use proper MobileDetectionService instead of inline detection

console.log('🔍 TRACE: Mobile detection defined successfully');

// Import enterprise scenes properly (fix the null reference issue)
import EnterpriseAuthenticatedMenuScene from './scenes/EnterpriseAuthenticatedMenuScene.js';
import EnterprisePhilosophyFlowScene from './scenes/EnterprisePhilosophyFlowScene.js';
import SignInSceneDOM from './scenes/SignInSceneDOM.js';
import SignUpSceneDOM from './scenes/SignUpSceneDOM.js';
// Re-enabling template scene imports - navigation buttons need these scenes
import ProfileSceneDOMTemplate from './scenes/ProfileSceneDOM_Template.js';
import MyLibrarySceneDOM from './scenes/MyLibrarySceneDOM.js';
import NotificationsSceneDOM from './scenes/NotificationsSceneDOM.js';
import PasswordResetSceneDOM from './scenes/PasswordResetSceneDOM.js';
import GameCenterSceneDOM from './scenes/GameCenterSceneDOM.js';
import AnalyticsSceneDOM from './scenes/AnalyticsSceneDOM.js';
import AdminPanelSceneDOM from './scenes/AdminPanelSceneDOM.js';
import CompanyVerificationSceneDOM from './scenes/CompanyVerificationSceneDOM.js';
import PhilosophyFlowSceneDOM from './scenes/PhilosophyFlowSceneDOM.js';
import PhilosophyFlowDesktopScene from './scenes/PhilosophyFlowDesktopScene.js';
import HallOfFameSceneTemplate from './scenes/HallOfFameSceneTemplate.js';
import HallOfFameSceneTemplateBeautiful from './scenes/HallOfFameSceneTemplate_BEAUTIFUL.js';
import HallOfFameDesktopTemplate from './scenes/HallOfFameDesktopTemplate.js';

console.log('🔍 TRACE: Enterprise scene placeholders defined');

console.log('🔍 TRACE: About to initialize DOM feature flags...');

// Initialize DOM feature flags (enable beautiful DOM experience by default)
// Removed pptHeroUseDOMBoot flag - always use beautiful DOM boot scene
console.log('🔍 TRACE: DOM feature flags initialized successfully');
if (!localStorage.getItem('pptHeroUseDOMMenus')) {
    localStorage.setItem('pptHeroUseDOMMenus', 'true');        // Beautiful menus
}
if (!localStorage.getItem('pptHeroUseDOMAuthMenu')) {
    localStorage.setItem('pptHeroUseDOMAuthMenu', 'true');     // Executive dashboard
}
// CRITICAL: Always ensure DOM Profile is enabled for complete DOM transition
localStorage.setItem('pptHeroUseDOMProfile', 'true');      // Force DOM profile for consistency
if (!localStorage.getItem('pptHeroUseNewAnalytics')) {
    localStorage.setItem('pptHeroUseNewAnalytics', 'true');    // Stunning analytics
}
if (!localStorage.getItem('pptHeroUseDOMHallOfFame')) {
    localStorage.setItem('pptHeroUseDOMHallOfFame', 'true');   // Beautiful Hall of Fame
}

console.log('🔍 TRACE: About to set enterprise mobile flag...');

// Enterprise Mobile Architecture Feature Flag (ENABLED for mobile UX implementation)
if (!localStorage.getItem('enableEnterpriseMobile')) {
    localStorage.setItem('enableEnterpriseMobile', 'true');   // ENABLED - activates mobile artifacts
}

console.log('🔍 TRACE: Enterprise mobile flag set successfully');

// Determine which scenes to use based on feature flags
const useDOMMenus = localStorage.getItem('pptHeroUseDOMMenus') === 'true';
const useDOMAuthMenu = localStorage.getItem('pptHeroUseDOMAuthMenu') === 'true';
const useUniversalLanding = localStorage.getItem('pptHeroUseUniversalLanding') === 'true';
const enableEnterpriseMobile = localStorage.getItem('enableEnterpriseMobile') === 'true';

// Enterprise Mobile Architecture Integration (preserves desktop experience)
const selectedBootScene = BootSceneDOM; // Always use beautiful DOM boot scene
const selectedMainMenuScene = useUniversalLanding ? MainMenuSceneUniversal : (useDOMMenus ? MainMenuSceneDOM : MainMenuScene);
const selectedGuestMenuScene = useUniversalLanding ? null : (useDOMMenus ? GuestMenuSceneDOM : GuestMenuScene);

// Scene selection will be handled in the registry to avoid duplicates

console.log(`🚀 Using beautiful DOM Boot Scene (old BootScene removed)`);
console.log(`🎨 Using ${useUniversalLanding ? 'Universal Landing' : (useDOMMenus ? 'DOM' : 'Phaser')} Menu Scenes based on feature flag`);
console.log(`📊 Using ${useDOMAuthMenu ? 'DOM' : 'Phaser'} Authenticated Menu based on feature flag`);
console.log(`🏆 Beautiful DOM interfaces active: Profile=${localStorage.getItem('pptHeroUseDOMProfile')}, Analytics=${localStorage.getItem('pptHeroUseNewAnalytics')}, HallOfFame=${localStorage.getItem('pptHeroUseDOMHallOfFame')}`);

// Enterprise Mobile Architecture Logging
console.log(`📱 Enterprise Mobile Architecture: ${enableEnterpriseMobile ? 'ENABLED' : 'DISABLED (Desktop Preserved)'}`);
console.log(`🖥️ Auth Scene: ${useDOMAuthMenu ? 'AuthenticatedMenuSceneDOM' : 'AuthenticatedMenuScene'} + Enterprise scenes when mobile`);
console.log(`🎭 Philosophy Scene: PhilosophyFlowScene + EnterprisePhilosophyFlowScene when mobile`);

// Ensure authUI is available globally for DOM scenes
import authUI from './ui/authUI.js';
window.authUI = authUI;
window.showAuthOverlay = showAuthOverlay; // Make showAuthOverlay globally available
console.log('🔐 AuthUI made available globally:', !!window.authUI);
console.log('🔐 showAuthOverlay made available globally:', !!window.showAuthOverlay);

// ENTERPRISE REFACTOR: Initialize enterprise services
console.log('🏢 Initializing enterprise services...');

// Initialize enterprise authentication service
window.enterpriseAuthService = enterpriseAuthService;
// CRITICAL: Initialize the service immediately
enterpriseAuthService.initialize().then(() => {
    console.log('✅ EnterpriseAuthService fully initialized and ready');
}).catch(error => {
    console.error('❌ EnterpriseAuthService initialization failed:', error);
});
console.log('✅ EnterpriseAuthService assigned to window');

// CRITICAL: Make all Enterprise services globally available
window.desktopStyleManager = desktopStyleManager;
window.DesktopStyleManager = desktopStyleManager; // Both formats for compatibility
window.mobileStyleManager = mobileStyleManager;
window.MobileStyleManager = mobileStyleManager; // Both formats for compatibility
window.enterpriseSceneManager = enterpriseSceneManager;
window.EnterpriseSceneManager = enterpriseSceneManager; // Both formats for compatibility
window.MenuRouting = MenuRouting;

console.log('✅ All Enterprise services assigned to window:', {
    desktopStyleManager: !!window.desktopStyleManager,
    mobileStyleManager: !!window.mobileStyleManager,
    enterpriseSceneManager: !!window.enterpriseSceneManager,
    MenuRouting: !!window.MenuRouting
});

// Initialize enterprise integration helper
window.enterpriseRefactorIntegration = enterpriseRefactorIntegration;
console.log('✅ EnterpriseRefactorIntegration initialized');

console.log('🏢 Enterprise services initialization complete');

let isInitialAuthCheck = true;
let authListenerRegistered = false; // Flag to prevent double registration
let initialSpecialAccessChecked = false;


// Add this to index.js
// Create a global helper function to reset transition flags
window.fixTransitionState = function() {
    console.log("Manually resetting transition flags");
    
    // Reset global flags
    window.sceneTransitionInProgress = false;
    window.sceneTransitionStartTime = null;
    window.initialTargetScene = null; // Store the target scene determined during boot

    
    if (window.sceneTransitionClearTimeout) {
        clearTimeout(window.sceneTransitionClearTimeout);
        window.sceneTransitionClearTimeout = null;
    }
    
    // Reset local flags in all known scenes
    const allScenes = window.gameInstance?.scene?.scenes || [];
    if (allScenes.length > 0) {
        allScenes.forEach(scene => {
            if (scene.isTransitioning) {
                console.log(`Resetting isTransitioning flag on ${scene.scene.key}`);
                scene.isTransitioning = false;
            }
        });
    }
    
    // Reset current active scene
    const currentScene = window.gameInstance?.getActiveScene?.();
    if (currentScene) {
        console.log(`Ensuring current scene ${currentScene.scene.key} has transition reset`);
        currentScene.isTransitioning = false;
        
        // Ensure input is enabled
        if (currentScene.input && !currentScene.input.enabled) {
            currentScene.input.enabled = true;
        }
    }
    
    // Let UIController try to fix input
    if (window.UIController) {
        window.UIController.enableSceneInput();
    }
    
    return "Transition flags reset";
};

// Log instructions
console.log("If scene transitions get stuck, run window.fixTransitionState() in console");
// --- Reusable Auth State Handling Logic ---
// Modified function from index.js for better scene transitions with Guest+

// src/index.js
// src/index.js

// --- Replace the ENTIRE handleAuthStateChangeLogic function with this ---
// src/index.js

// --- Replace the ENTIRE handleAuthStateChangeLogic function with this ---
async function handleAuthStateChangeLogic(user) {
  const functionStartTime = Date.now();
  const isInitialCheck = isInitialAuthCheck;
  isInitialAuthCheck = false; // Set flag after reading
  console.log(`%c[AuthLogic ${functionStartTime}] User: ${user?.uid}, Verified: ${user?.emailVerified}, Initial: ${isInitialCheck}`, 'color: #FF8C00');

  // CRITICAL FIX: Initialize user-scoped storage to prevent data contamination
  const userId = user?.uid || 'guest';
  UserScopedStorage.initialize(userId);
  
  // ENTERPRISE: Clean up corrupted localStorage that could affect auth flow
  if (user?.uid !== window.lastUserId) {
    console.log('🧹 User changed - cleaning potentially corrupted localStorage');
    
    // Clean up auth-related localStorage that could interfere
    const authKeys = ['authState', 'lastAuthCheck', 'authError', 'signInAttempts'];
    authKeys.forEach(key => {
      if (localStorage.getItem(key)) {
        localStorage.removeItem(key);
        console.log(`🧹 Cleaned auth localStorage: ${key}`);
      }
    });
    
    window.lastUserId = user?.uid;
  }

  // CRITICAL: USER SWITCHING DETECTION AND DATA ISOLATION
  const previousUser = window.lastAuthUser;
  window.lastAuthUser = user;
  
  if (!isInitialCheck && previousUser?.uid && user?.uid && previousUser.uid !== user.uid) {
    console.log(`🔄 USER SWITCH DETECTED: ${previousUser.uid} → ${user.uid}`);
    window.handleUserSwitch(previousUser, user);
  } else if (!isInitialCheck && previousUser?.uid && !user) {
    console.log(`🔒 USER LOGOUT DETECTED: ${previousUser.uid} → null`);
    window.cleanUserSwitchData();
  }

  try {
      // --- Wait for Game/SceneManager ---
      let bootCheckCounter = 0;
      const maxBootChecks = 20; // 5 seconds total wait
      console.log(`[AuthLogic ${functionStartTime}] Checking game/SceneManager readiness...`);
      while ((!window.gameInstance || !window.gameInstance.scene || !sceneManager.gameInstance) && bootCheckCounter < maxBootChecks) {
          // console.log(`[AuthLogic ${functionStartTime}] Game/SceneManager not ready (attempt ${bootCheckCounter + 1}), delaying 250ms...`);
          await new Promise(resolve => setTimeout(resolve, 250));
          bootCheckCounter++;
      }
      if (!window.gameInstance || !window.gameInstance.scene || !sceneManager.gameInstance) {
          console.error(`[AuthLogic ${functionStartTime}] Game/SceneManager boot timeout after ${bootCheckCounter} checks. Aborting auth logic.`);
          return; // Cannot proceed without game instance
      }
      console.log(`[AuthLogic ${functionStartTime}] Game/SceneManager ready.`);
      // --- End Wait ---

      const specialAccess = hasSpecialAccess();
      const isVerifiedUser = user && user.emailVerified;
      const isGuestPlus = !user && specialAccess;
      const isEffectivelyLoggedIn = isVerifiedUser || isGuestPlus;
      console.log(`[AuthLogic ${functionStartTime}] SpecialAccess=${specialAccess}, EffectivelyLoggedIn=${isEffectivelyLoggedIn}`);

      // --- Update Ribbon ---
      const usernameLabel = document.getElementById("ribbon-username-label");
      const logoutBtn = document.getElementById("ribbon-logout-btn");
      const analyticsBtn = document.getElementById("ribbon-analytics-btn");
      if (usernameLabel && logoutBtn && analyticsBtn) {
          if (isEffectivelyLoggedIn) {
              let displayName = "Player";
              if (isVerifiedUser) {
                  displayName = user.displayName || user.email || "User";
                  // Attempt to fetch profile name async, don't block
                  db.collection("userProfiles").doc(user.uid).get().then(doc => {
                       if(doc.exists && usernameLabel) usernameLabel.textContent = doc.data().displayName || user.email || "User";
                  }).catch(()=>{/* ignore fetch error */});
              } else { // Guest+
                  displayName = getSpecialAccessDisplayName();
              }
              usernameLabel.textContent = displayName; // Set immediately with fallback
              logoutBtn.style.display = 'inline-block';
              analyticsBtn.style.display = 'inline-block'; // Show analytics for logged-in users
          } else { // Guest
              usernameLabel.textContent = "Guest";
              logoutBtn.style.display = 'none';
              analyticsBtn.style.display = 'none'; // Hide analytics for guests
          }
      } else { console.warn("[AuthLogic] Ribbon elements missing during update."); }
      // --- End Ribbon Update ---

      // --- Claim Scores (Only on initial check for verified user) ---
      if (isVerifiedUser && isInitialCheck) {
         try {
             const profileDoc = await db.collection("userProfiles").doc(user.uid).get();
             const profileName = (profileDoc.exists && profileDoc.data().displayName) ? profileDoc.data().displayName : (user.displayName || user.email);
             await claimAnonymousScores(user.uid, profileName);
         } catch(e){ console.error("Score claim error:", e); }
      }
      // --- End Claim Scores ---

      // --- Scene Transition Logic ---
      let targetSceneKey = null;
      let currentSceneKey = sceneManager.currentSceneKey; // Get current scene from manager

      // Get the actual active Phaser scene instance if possible, for more accurate checks
      const currentSceneInstance = sceneManager.getActiveSceneInstance();
      if (currentSceneInstance && currentSceneInstance.scene.key !== currentSceneKey) {
           console.warn(`[AuthLogic ${functionStartTime}] SceneManager state correction. Manager had ${currentSceneKey}, actual is ${currentSceneInstance.scene.key}`);
           currentSceneKey = currentSceneInstance.scene.key; // Correct the key
           sceneManager.currentSceneKey = currentSceneKey; // Update manager state
      }
       console.log(`[AuthLogic ${functionStartTime}] Current Scene Key: ${currentSceneKey}`);

      // --- Define Scene Access Rules ---
      const guestOnlyScenes = ["MainMenuScene", "GuestMenuScene", "MainMenuSceneDOM", "GuestMenuSceneDOM", "MainMenuSceneUniversal", "SignInSceneDOM", "SignUpSceneDOM"]; // Scenes only guests should be in
      // Corrected: Auth required, but allow Guest+
      const effectivelyAuthScenes = [
        "AuthenticatedMenuScene", "AuthenticatedMenuSceneDOM", "ProfileScene", "MultiplayerMenuScene",
        "CreateGameScene", "JoinGameScene", "LobbyScene",
        "MultiplayerGameScene", "AdminConsoleScene"
        // MultiplayerGameOverScene should be accessible by anyone who finished a game
      ];
      const publicScenes = ["MultiplayerGameOverScene"]; // Accessible by anyone
      // --- End Scene Access Rules ---

      if (isEffectivelyLoggedIn) {
          // User is logged in (Verified OR Guest+)
          if (guestOnlyScenes.includes(currentSceneKey) || currentSceneKey === 'BootSceneDOM' || (!currentSceneKey && !isInitialAuthCheck)) {
              targetSceneKey = useDOMAuthMenu ? "AuthenticatedMenuSceneDOM" : "AuthenticatedMenuScene";
              console.log(`[AuthLogic ${functionStartTime}] Logged in user (${isVerifiedUser ? 'Verified':'Guest+'}) in guest/boot/null scene -> Target: ${targetSceneKey}`);
          } else if (!currentSceneKey && isInitialAuthCheck) {
              // Initial auth check with no scene - defer to let boot scene start
              console.log(`[AuthLogic ${functionStartTime}] Initial auth check with no active scene - deferring to allow boot scene startup`);
              return; // Exit early, let boot scene handle transition
          } else {
              console.log(`[AuthLogic ${functionStartTime}] Logged in user already in auth area/game (${currentSceneKey}). No scene change needed by auth state.`);
          }
      } else {
          // User is a true Guest (not logged in, no special access)
          if (effectivelyAuthScenes.includes(currentSceneKey)) {
              // CRITICAL FIX: Always route to DOM or Universal scenes for logout
              targetSceneKey = useUniversalLanding ? "MainMenuSceneUniversal" : 
                             (useDOMMenus ? "GuestMenuSceneDOM" : "MainMenuSceneDOM"); 
              console.log(`[AuthLogic ${functionStartTime}] Logged out user in auth-only scene -> Target: ${targetSceneKey}`);
          } else if (currentSceneKey === 'BootSceneDOM') {
               // CRITICAL FIX: Always route to DOM or Universal scenes for logout
               targetSceneKey = useUniversalLanding ? "MainMenuSceneUniversal" : "GuestMenuSceneDOM";
               console.log(`[AuthLogic ${functionStartTime}] Logged out user in boot scene -> Target: ${targetSceneKey}`);
          } else if (!currentSceneKey && isInitialAuthCheck) {
               // Initial auth check with no scene - defer to let boot scene start
               console.log(`[AuthLogic ${functionStartTime}] Initial guest auth check with no active scene - deferring to allow boot scene startup`);
               return; // Exit early, let boot scene handle transition
          } else {
               console.log(`[AuthLogic ${functionStartTime}] Logged out user in guest area/game (${currentSceneKey}). No scene change needed by auth state.`);
          }
      }

      // --- Handle BootSceneDOM Deferral ---
      if (currentSceneKey === 'BootSceneDOM') {
           // CRITICAL FIX: Universal landing only for guest users, authenticated users go to executive dashboard
           const useUniversalLanding = localStorage.getItem('pptHeroUseUniversalLanding') === 'true';
           
           if (useUniversalLanding && !isEffectivelyLoggedIn) {
             // Only use universal landing for guest users
             window.initialTargetScene = 'MainMenuSceneUniversal';
             console.log(`%c[AuthLogic ${functionStartTime}] Universal landing enabled for guest - target: MainMenuSceneUniversal`, 'color: #00FF88');
           } else {
            // Authenticated users go to appropriate authenticated menu regardless of universal landing flag
            // FIXED: Always use AuthenticatedMenuSceneDOM for both mobile and desktop
            // Mobile/desktop template selection happens within the scene
            const authScene = "AuthenticatedMenuSceneDOM";
            window.initialTargetScene = targetSceneKey || (isEffectivelyLoggedIn ? authScene : (useUniversalLanding ? "MainMenuSceneUniversal" : (useDOMMenus ? "GuestMenuSceneDOM" : "GuestMenuScene")));
             console.log(`%c[AuthLogic ${functionStartTime}] Auth-aware routing for ${currentSceneKey} - target: ${window.initialTargetScene}`, 'color: #00FF88');
           }
           
           console.log(`%c[AuthLogic ${functionStartTime}] In ${currentSceneKey}. Storing initial target: ${window.initialTargetScene} for ${currentSceneKey} to handle.`, 'color: #FFD700');
           targetSceneKey = null; // Prevent transition logic below from running immediately
      }
      // --- End BootScene Deferral ---

      // --- Execute Scene Transition if Needed ---
      // CRITICAL FIX: Defer to boot scene when currentSceneKey is null (initial state)
      if (!currentSceneKey && isInitialAuthCheck) {
          console.log(`%c[AuthLogic ${functionStartTime}] Initial auth check with null scene - deferring to boot scene. Target stored: ${targetSceneKey}`, 'color: #FFD700');
          
          // CRITICAL FIX: Authenticated users should go to authenticated menu, not universal landing
          const useUniversalLanding = localStorage.getItem('pptHeroUseUniversalLanding') === 'true';
          
          if (useUniversalLanding && !isEffectivelyLoggedIn) {
            // Only use universal landing for guest users
            window.initialTargetScene = 'MainMenuSceneUniversal';
            console.log(`%c[AuthLogic ${functionStartTime}] Universal landing enabled for guest - target: MainMenuSceneUniversal`, 'color: #00FF88');
          } else {
            // Authenticated users go to appropriate authenticated menu regardless of universal landing flag
            // CRITICAL FIX: Use proper enterprise mobile routing (fallback to base if enterprise not loaded)
            const baseAuthScene = useDOMAuthMenu ? "AuthenticatedMenuSceneDOM" : "AuthenticatedMenuScene";
            const authScene = (enableEnterpriseMobile && isMobileDevice && EnterpriseAuthenticatedMenuScene) ? "EnterpriseAuthenticatedMenuScene" : baseAuthScene;
            window.initialTargetScene = targetSceneKey || (isEffectivelyLoggedIn ? authScene : (useUniversalLanding ? "MainMenuSceneUniversal" : "GuestMenuSceneDOM"));
            console.log(`%c[AuthLogic ${functionStartTime}] Auth-aware routing - target: ${window.initialTargetScene}`, 'color: #00FF88');
          }
          
          return; // Exit early to let boot scene handle
      } else if (targetSceneKey && targetSceneKey !== currentSceneKey) {
          console.log(`%c[AuthLogic ${functionStartTime}] Auth state requires scene change. Requesting transition from ${currentSceneKey || 'N/A'} to ${targetSceneKey}.`, 'color: #00d4ff');
          // --- Use SceneManager directly ---
          await sceneManager.switchToScene(targetSceneKey);
          // --- End Use SceneManager ---
      } else if (!targetSceneKey && currentSceneKey !== 'BootSceneDOM') {
           console.log(`[AuthLogic ${functionStartTime}] No scene transition required by auth state. Current: ${currentSceneKey}`);
           // Ensure input is enabled if no overlay is active and not transitioning
           if (window.UIController && !window.UIController.isAnyOverlayVisible() && !sceneManager.isTransitioning) {
                window.UIController.enableSceneInput();
           }
      } else if (currentSceneKey === 'BootSceneDOM') {
           console.log(`[AuthLogic ${functionStartTime}] Transition deferred to BootSceneDOM.`);
      }
      // --- End Scene Transition Logic ---

  } catch (error) {
      console.error(`[AuthLogic ${functionStartTime}] CRITICAL Error in auth state handling:`, error);
      try {
          // Attempt recovery ONLY if not already transitioning
          if (!sceneManager.isTransitioning) {
              console.error("Attempting recovery to DOM scene due to auth logic error.");
              const useUniversalLanding = localStorage.getItem('pptHeroUseUniversalLanding') === 'true';
              const recoveryScene = useUniversalLanding ? "MainMenuSceneUniversal" : "GuestMenuSceneDOM";
              await sceneManager.switchToScene(recoveryScene);
          } else {
              console.error("Auth logic error occurred during an existing scene transition. Cannot force recovery.");
          }
      } catch (recoveryError) { console.error("Auth logic recovery failed:", recoveryError); }
  } finally {
      console.log(`%c[AuthLogic ${functionStartTime}] State handling finished.`, 'color: #FF8C00');
  }
}
// --- END REPLACE handleAuthStateChangeLogic ---
// --- END REPLACE handleAuthStateChangeLogic ---REPLACE handleAuthStateChangeLogic ---
// --- Replace the ENTIRE handleAuthStateChangeLogic function with this ---
// src/index.js

// --- Replace the ENTIRE handleAuthStateChangeLogic function with this ---
// --- Replace the ENTIRE handleAuthStateChangeLogic function with this ---
// --- Replace the ENTIRE handleAuthStateChangeLogic function ---

// --- END REPLACEMENT FUNCTION ---
// --- END OF REPLACEMENT FUNCTION ---

// --- Define the Listener Function Separately ---
const firebaseAuthStateListener = async (user) => {
  console.log(`>>> Firebase onAuthStateChanged TRIGGERED with user: ${user ? user.uid : 'null'}`);
  try {
      await handleAuthStateChangeLogic(user); // Call the reusable logic
  } catch (error) {
      console.error("Error inside firebaseAuthStateListener's call to handleAuthStateChangeLogic:", error);
      // Add fallback or error reporting here if necessary
  }
};

// Add this to index.js - After the Firebase auth listener registration

// --- MODIFY this listener ---
window.addEventListener('special-access-granted', (event) => {
  console.log(">>> Special access granted event received.");

  // Force reset any scene transition flags *before* doing anything else
  if (typeof window.fixTransitionState === 'function') {
      window.fixTransitionState();
  }

  // Record the session details if provided
  if (event.detail?.sessionId) {
      console.log("Guest+ session established with ID:", event.detail.sessionId);
  }

  // --- REMOVED: window.dispatchEvent(new CustomEvent('auth-change')); ---

  // --- ADD: Directly trigger the logic IF game is ready ---
  // This ensures the state is checked immediately after grant
  console.log(">>> Directly calling auth logic after special access grant.");
   if (window.gameInstance && window.gameInstance.scene && sceneManager.gameInstance) {
       handleAuthStateChangeLogic(null); // Pass null because Firebase user is null for Guest+
   } else {
       console.warn("Game/SceneManager not ready when special access granted, auth state check deferred.");
       // The regular auth listener will eventually pick it up.
   }
  // --- END ADD ---
});
  
  // Listener for special access clearing
  window.addEventListener('special-access-cleared', () => {
    console.log(">>> Special access cleared event received.");
    // Trigger auth state change to update UI and scene
    window.dispatchEvent(new CustomEvent('auth-change'));
  });
  
  // Listener for special access expiration
  window.addEventListener('special-access-expired', () => {
    console.log(">>> Special access expired event received.");
    // Trigger auth state change to update UI and scene
    window.dispatchEvent(new CustomEvent('auth-change'));
  });
  
  // --- Listener for Custom 'auth-change' Event ---
  window.addEventListener('auth-change', () => {
    console.log(">>> Custom 'auth-change' event received.");
    const currentUser = auth.currentUser; // Get current Firebase user state
    console.log(`>>> Custom event triggering logic with user: ${currentUser ? currentUser.uid : 'null'}`);
    // Directly call the reusable logic function
    handleAuthStateChangeLogic(currentUser);
  });

// --- Project Version ---
window.PROJECT_VERSION = PROJECT_VERSION; // Use webpack-defined version from package.json
window.DEPLOYMENT_TIMESTAMP = Date.now(); // Force cache invalidation
console.log('🔄 CACHE BUSTER: Forcing complete reload - timestamp:', window.DEPLOYMENT_TIMESTAMP);
console.log(`🚀 DeckOps Enterprise Mobile v${PROJECT_VERSION} - Deployment:`, new Date().toISOString());

// --- PWA Service Worker Registration ---
// PWA Service Worker Registration - Re-enabled
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js');
      console.log('🚀 PWA: Service Worker registered successfully:', registration.scope);
      
      // Check for updates
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            // New version available
            showUpdateAvailableNotification();
          }
        });
      });
    } catch (error) {
      console.error('❌ PWA: Service Worker registration failed:', error);
    }
  });
}

// --- PWA Install Prompt ---
let deferredPrompt;
window.addEventListener('beforeinstallprompt', (e) => {
  console.log('📱 PWA: Install prompt available');
  e.preventDefault();
  deferredPrompt = e;
  
  // ENTERPRISE FIX: Only show if no template overlays are active
  if (!document.getElementById('auth-menu-dom-overlay') && 
      !document.querySelector('[id$="-scene-overlay"]')) {
    showInstallButton();
  } else {
    console.log('📱 PWA: Install prompt deferred - template overlay active');
  }
});

// iOS Safari specific PWA detection and install prompt
function detectiOSPWA() {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isInStandaloneMode = window.navigator.standalone === true;
  const isInWebAppiOSMode = window.matchMedia('(display-mode: standalone)').matches;
  
  if (isIOS && !isInStandaloneMode && !isInWebAppiOSMode) {
    // Show iOS-specific install instructions
    setTimeout(() => showIOSInstallPrompt(), 3000);
  }
}

function showIOSInstallPrompt() {
  if (document.getElementById('ios-install-prompt')) return;
  
  const prompt = document.createElement('div');
  prompt.id = 'ios-install-prompt';
  prompt.style.cssText = `
    position: fixed;
    bottom: 20px;
    left: 20px;
    right: 20px;
    background: linear-gradient(135deg, #1e293b, #334155);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 16px;
    padding: 20px;
    z-index: 100001;
    color: white;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
    transform: translateY(100px);
    transition: transform 0.3s ease;
  `;
  
  prompt.innerHTML = `
    <div style="display: flex; justify-content: space-between; align-items: flex-start;">
      <div style="flex: 1;">
        <div style="font-size: 18px; font-weight: 700; margin-bottom: 8px;">📱 Install DeckOps.ai</div>
        <div style="font-size: 14px; color: rgba(255, 255, 255, 0.8); margin-bottom: 12px;">
          Tap <span style="color: #00d4ff;">Share</span> → <span style="color: #00d4ff;">Add to Home Screen</span>
        </div>
      </div>
      <button onclick="this.parentElement.parentElement.remove()" style="background: none; border: none; color: rgba(255, 255, 255, 0.6); font-size: 24px; padding: 0; margin-left: 16px;">×</button>
    </div>
  `;
  
  document.body.appendChild(prompt);
  
  requestAnimationFrame(() => {
    prompt.style.transform = 'translateY(0)';
  });
  
  // Auto-hide after 10 seconds
  setTimeout(() => {
    if (prompt.parentElement) {
      prompt.style.transform = 'translateY(100px)';
      setTimeout(() => prompt.remove(), 300);
    }
  }, 10000);
}

window.addEventListener('appinstalled', () => {
  console.log('🎉 PWA: App installed successfully');
  hideInstallButton();
  // Track installation analytics
  if (window.gtag) {
    gtag('event', 'pwa_install', {
      event_category: 'engagement',
      event_label: 'mobile_app_installed'
    });
  }
});

function showInstallButton() {
  // ENTERPRISE FIX: Don't show PWA button if template overlay is active
  if (document.getElementById('auth-menu-dom-overlay') || 
      document.querySelector('[id$="-scene-overlay"]')) {
    console.log('📱 PWA: Install button hidden - template overlay active');
    return;
  }
  
  // Create install button if it doesn't exist
  if (!document.getElementById('pwa-install-btn')) {
    const installBtn = document.createElement('button');
    installBtn.id = 'pwa-install-btn';
    installBtn.innerHTML = '📱 Install App';
    installBtn.style.cssText = `
      position: fixed;
      bottom: 20px;
      right: 20px;
      background: linear-gradient(135deg, #00d4ff, #0099cc);
      color: white;
      border: none;
      padding: 12px 20px;
      border-radius: 25px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      z-index: 20000;
      box-shadow: 0 4px 15px rgba(0, 212, 255, 0.3);
      transition: all 0.3s ease;
    `;
    
    installBtn.addEventListener('click', installPWA);
    installBtn.addEventListener('mouseenter', () => {
      installBtn.style.transform = 'translateY(-2px)';
      installBtn.style.boxShadow = '0 6px 20px rgba(0, 212, 255, 0.4)';
    });
    installBtn.addEventListener('mouseleave', () => {
      installBtn.style.transform = 'translateY(0)';
      installBtn.style.boxShadow = '0 4px 15px rgba(0, 212, 255, 0.3)';
    });
    
    document.body.appendChild(installBtn);
  }
}

function hideInstallButton() {
  const installBtn = document.getElementById('pwa-install-btn');
  if (installBtn) {
    installBtn.remove();
  }
}

async function installPWA() {
  if (deferredPrompt) {
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    console.log(`🎯 PWA: User ${outcome} the install prompt`);
    
    if (outcome === 'accepted') {
      console.log('✅ PWA: User accepted the install prompt');
    }
    
    deferredPrompt = null;
    hideInstallButton();
  }
}

function showUpdateAvailableNotification() {
  // Create update notification
  const updateNotification = document.createElement('div');
  updateNotification.id = 'pwa-update-notification';
  updateNotification.innerHTML = `
    <div style="
      position: fixed;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      background: rgba(0, 0, 0, 0.9);
      color: white;
      padding: 15px 25px;
      border-radius: 10px;
      z-index: 20001;
      font-size: 14px;
      text-align: center;
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
    ">
      🆕 New version available! 
      <button onclick="window.location.reload()" style="
        background: #00d4ff;
        color: white;
        border: none;
        padding: 5px 15px;
        border-radius: 5px;
        margin-left: 10px;
        cursor: pointer;
      ">Update</button>
    </div>
  `;
  
  document.body.appendChild(updateNotification);
  
  // Auto-hide after 10 seconds
  setTimeout(() => {
    if (updateNotification.parentNode) {
      updateNotification.remove();
    }
  }, 10000);
}

// --- Clean up previous instance if hot-reloading ---
if (window.gameInstance) {
  try { 
    console.log('🧹 Cleaning up previous game instance...');
    window.gameInstance.destroy(true, true); // Complete cleanup
    window.gameInstance = null;
  } catch (e) { 
    console.warn("Error destroying previous game instance:", e); 
  }
  const container = document.getElementById("game-container");
  if (container) container.innerHTML = ""; // Clear container
}

console.log('🔍 EARLY DEBUG: Checking Phaser initialization status...');
console.log('🔍 EARLY DEBUG: window.phaserGameInitialized =', window.phaserGameInitialized);

// CRITICAL FIX: Force clear the initialization flag to allow Phaser creation
if (window.phaserGameInitialized) {
  console.warn('⚠️ EARLY DEBUG: Clearing stuck phaserGameInitialized flag');
  window.phaserGameInitialized = false;
}

// Always initialize Phaser (removed blocking conditional)
console.log('🚀 EARLY DEBUG: Force initializing Phaser game...');
window.phaserGameInitialized = true;

// --- Initialize Mobile Services ---
// UNIFIED: Use single mobile detection service
import { MobileDetectionService } from './services/MobileDetectionService.js';
const isMobileDevice = MobileDetectionService.isMobile();

// REMOVED: Workaround - proper fix applied to CanvasFixer
console.log('🔍 EARLY DEBUG: Mobile detection result:', isMobileDevice, 'Width:', window.innerWidth);

if (isMobileDevice) {
  console.log('📱 MOBILE DEVICE DETECTED - Initializing UNIFIED mobile system...');
  
  try {
    // ENTERPRISE: Initialize service locator first
    if (!window.serviceLocator) {
      window.serviceLocator = new Map();
    }
    window.serviceLocator.set('MobileDetectionService', MobileDetectionService);
    
    // CRITICAL: Make MobileDetectionService available globally for enterprise services
    window.MobileDetectionService = MobileDetectionService;
    
    // UNIFIED: Single mobile system replaces all others (using singleton pattern)
    console.log('🎯 Initializing UnifiedMobileSystem...');
    const unifiedMobileSystem = UnifiedMobileSystem.getInstance();
    window.serviceLocator.set('UnifiedMobileSystem', unifiedMobileSystem);
    
    // CRITICAL: Make UnifiedMobileSystem globally available
    window.UnifiedMobileSystem = UnifiedMobileSystem; // Class
    window.unifiedMobileSystem = unifiedMobileSystem; // Instance
    
    unifiedMobileSystem.initialize();
    
    console.log('✅ UnifiedMobileSystem registered in service locator and globally available');
    
    // Register for enterprise validation
    window.unifiedMobile = {
      isEnabled: true,
      getStatus: () => unifiedMobileSystem.getStatus(),
      instance: unifiedMobileSystem
    };
    
    // Initialize offline manager (keep for analytics)
    console.log('🔄 Initializing MobileOfflineManager...');
  const mobileOfflineManager = new MobileOfflineManager();
  window.mobileOfflineManager = mobileOfflineManager;
    console.log('✅ MobileOfflineManager initialized');
  
    // Initialize mobile analytics (keep for tracking)
    console.log('📊 Initializing MobileAnalytics...');
  const mobileAnalytics = new MobileAnalytics(mobileOfflineManager);
  window.mobileAnalytics = mobileAnalytics;
    console.log('✅ MobileAnalytics initialized');
    
    // UNIFIED: Swipe navigation is handled by UnifiedMobileSystem
    console.log('✅ Unified mobile system handles all interactions');
    
    // Initialize push notifications support (don't request permission yet)
    if ('Notification' in window && 'serviceWorker' in navigator) {
      setupPushNotificationSupport();
    }
    
    // UNIFIED: Simple mobile debug utilities
    window.testUnifiedMobile = () => {
      console.log('🧪 UNIFIED MOBILE TEST');
      console.log('📱 Status:', UnifiedMobileSystem.getStatus());
      
      // Test button clicks
      const buttons = document.querySelectorAll('button, [data-action], [data-game]');
      console.log(`🔘 Found ${buttons.length} interactive elements`);
      
      // Test scrolling
      console.log('📜 Testing scroll...');
      console.log('Body overflow:', getComputedStyle(document.body).overflow);
      console.log('Container overflow:', getComputedStyle(document.getElementById('game-container') || {}).overflow);
      
      // Test device detection
      const system = window.serviceLocator?.get('UnifiedMobileSystem');
      console.log('📱 Device info:', system?.deviceInfo);
    };
    
    window.fixMobileIssues = () => {
      console.log('🛠️ FIXING all mobile issues...');
      const system = window.serviceLocator?.get('UnifiedMobileSystem');
      if (!system) {
        console.error('❌ UnifiedMobileSystem not found in service locator');
        return;
      }
      system.fixViewportAndCSS();
      system.fixSceneTransitions();
      console.log('✅ All mobile issues fixed');
    };
    
    // ENTERPRISE: Add comprehensive validation
    window.validateArchitecture = () => {
      return MobileArchitectureValidator.validateComplete();
    };
    
    // EMERGENCY: Add white screen diagnostics
    window.diagnoseWhiteScreen = () => {
      console.log('🚨 WHITE SCREEN DIAGNOSTICS:');
      console.log('🎮 Game exists:', !!window.game);
      console.log('🎬 Scenes available:', window.game?.scene?.scenes?.length || 0);
      console.log('🎯 Active scenes:', window.game?.scene?.scenes?.filter(s => s.scene.isActive()).map(s => s.scene.key) || []);
      console.log('📋 Scene keys:', window.game?.scene?.keys || []);
      console.log('🎨 Canvas exists:', !!document.querySelector('canvas'));
      console.log('📦 Game container:', !!document.getElementById('game-container'));
      console.log('👁️ Game container visible:', document.getElementById('game-container')?.style.visibility);
      console.log('🎪 Preloader visible:', !!document.getElementById('preloader'));
      console.log('🔍 Body content:', document.body.children.length, 'elements');
      
      // Check for errors
      console.log('❌ Check console for errors above this line');
      
      return {
        gameExists: !!window.game,
        sceneCount: window.game?.scene?.scenes?.length || 0,
        activeScenes: window.game?.scene?.scenes?.filter(s => s.scene.isActive()).map(s => s.scene.key) || [],
        canvasExists: !!document.querySelector('canvas'),
        containerExists: !!document.getElementById('game-container'),
        preloaderExists: !!document.getElementById('preloader')
      };
    };
    
    window.getMobileStatus = () => {
      const system = window.serviceLocator?.get('UnifiedMobileSystem');
      if (!system) {
        console.error('❌ UnifiedMobileSystem not found in service locator');
        return { error: 'System not initialized' };
      }
      const status = system.getStatus();
      console.log('📱 UNIFIED MOBILE STATUS:', status);
      return status;
    };
    
    // REMOVED: Orphaned gesture test code
    // All testing is now handled by UnifiedMobileSystem
    
    // Add mobile scrolling debug utility
    window.debugMobileScrolling = () => {
      console.log('🔍 MOBILE SCROLLING DEBUG:');
      
      const elements = [
        { name: 'body', el: document.body },
        { name: 'html', el: document.documentElement },
        { name: 'game-container', el: document.getElementById('game-container') },
        { name: 'canvas', el: document.querySelector('canvas') }
      ];
      
      elements.forEach(({ name, el }) => {
        if (el) {
          const styles = window.getComputedStyle(el);
          console.log(`📱 ${name}:`, {
            overflow: styles.overflow,
            overflowY: styles.overflowY,
            touchAction: styles.touchAction,
            pointerEvents: styles.pointerEvents,
            position: styles.position,
            height: styles.height,
            webkitOverflowScrolling: styles.webkitOverflowScrolling
          });
        } else {
          console.log(`❌ ${name}: Element not found`);
        }
      });
      
      // Check if scrolling is actually possible
      const scrollHeight = document.body.scrollHeight;
      const clientHeight = document.body.clientHeight;
      console.log(`📏 Scroll info: scrollHeight=${scrollHeight}px, clientHeight=${clientHeight}px, scrollable=${scrollHeight > clientHeight}`);
    };
    
    window.fixMobileScrolling = () => {
      console.log('🛠️ FORCE FIXING mobile scrolling...');
      const unifiedMobileInstance = window.unifiedMobileSystem || UnifiedMobileSystem.getInstance();
      if (unifiedMobileInstance && typeof unifiedMobileInstance.fixViewportAndCSS === 'function') {
        unifiedMobileInstance.fixViewportAndCSS();
        console.log('✅ Unified scrolling fix applied');
      } else {
        console.warn('UnifiedMobileSystem instance not available for scrolling fix');
      }
    };
    
    // EMERGENCY: White screen recovery
    window.emergencyRecovery = () => {
      console.log('🚨 EMERGENCY WHITE SCREEN RECOVERY');
      
      // Force show game container
      const container = document.getElementById('game-container');
      if (container) {
        container.style.visibility = 'visible';
        container.style.display = 'block';
        container.style.opacity = '1';
        console.log('✅ Game container forced visible');
      }
      
      // Hide preloader
      const preloader = document.getElementById('preloader');
      if (preloader) {
        preloader.style.display = 'none';
        console.log('✅ Preloader hidden');
      }
      
      // Force scene transition if none active
      const activeScenes = window.game?.scene?.scenes?.filter(s => s.scene.isActive()) || [];
      if (activeScenes.length === 0) {
        console.log('🚀 No active scenes - forcing GuestMenuSceneDOM');
        if (window.game?.scene) {
          window.game.scene.start('GuestMenuSceneDOM');
        }
      }
      
      // Apply unified mobile fixes
      const unifiedMobileInstance = window.unifiedMobileSystem || UnifiedMobileSystem.getInstance();
      if (unifiedMobileInstance && typeof unifiedMobileInstance.fixViewportAndCSS === 'function') {
        unifiedMobileInstance.fixViewportAndCSS();
      } else {
        console.warn('UnifiedMobileSystem instance not available for emergency recovery');
      }
      
      console.log('✅ Emergency recovery completed');
    };
    
    // REMOVED: Orphaned ContextAwareTouchManager reference
    // Touch status is now handled by UnifiedMobileSystem
    
    // Add scene routing debug utility
    window.debugMobileRouting = () => {
      const enableEnterpriseMobile = localStorage.getItem('enableEnterpriseMobile');
      const isMobile = MobileDetectionService.isMobile();
      const currentScene = window.game?.scene?.scenes?.find(s => s.scene.isActive())?.scene?.key;
      const allScenes = window.game?.scene?.scenes?.map(s => ({ key: s.scene.key, active: s.scene.isActive() })) || [];
      const initialTarget = window.initialTargetScene;
      
      console.log('🔍 MOBILE ROUTING DEBUG:');
      console.log('📱 enableEnterpriseMobile:', enableEnterpriseMobile);
      console.log('📱 isMobile detected:', isMobile);
      console.log('📱 Current scene:', currentScene);
      console.log('📱 Initial target scene:', initialTarget);
      console.log('📱 All scenes:', allScenes);
      console.log('📱 User agent:', navigator.userAgent);
      console.log('📱 Screen size:', `${window.innerWidth}x${window.innerHeight}`);
      console.log('📱 Touch support:', 'ontouchstart' in window);
      console.log('📱 SceneManager available:', !!window.sceneManager);
      
      return {
        enableEnterpriseMobile,
        isMobile,
        currentScene,
        initialTarget,
        allScenes,
        userAgent: navigator.userAgent,
        screenSize: `${window.innerWidth}x${window.innerHeight}`,
        touchSupport: 'ontouchstart' in window,
        sceneManagerAvailable: !!window.sceneManager
      };
    };
    
    // Add scene transition debug and recovery utility
    window.forceSceneTransition = (sceneKey) => {
      console.log(`🚀 FORCE transitioning to: ${sceneKey}`);
      if (window.sceneManager) {
        window.sceneManager.switchToScene(sceneKey);
      } else if (window.game) {
        window.game.scene.start(sceneKey);
      } else {
        console.error('❌ No scene management available');
      }
    };
    
    // Add scene registration debug utility  
    window.debugSceneRegistration = () => {
      console.log('🔍 SCENE REGISTRATION DEBUG:');
      console.log('🎮 Game instance:', !!window.game);
      console.log('🎮 Game instance type:', typeof window.game);
      console.log('🎬 Scene manager:', !!window.game?.scene);
      console.log('📋 Registered scenes:', window.game?.scene?.keys || []);
      console.log('🎯 Scene instances:', window.game?.scene?.scenes?.map(s => s.scene.key) || []);
      
      // Check ALL scene imports
      const sceneImports = {
        // BootScene: removed - using BootSceneDOM only
        BootSceneDOM: typeof BootSceneDOM,
        MainMenuScene: typeof MainMenuScene,
        MainMenuSceneDOM: typeof MainMenuSceneDOM,
        GuestMenuScene: typeof GuestMenuScene,
        GuestMenuSceneDOM: typeof GuestMenuSceneDOM,
        AuthenticatedMenuScene: typeof AuthenticatedMenuScene,
        AuthenticatedMenuSceneDOM: typeof AuthenticatedMenuSceneDOM,
        EnterpriseAuthenticatedMenuScene: typeof EnterpriseAuthenticatedMenuScene,
        EnterprisePhilosophyFlowScene: typeof EnterprisePhilosophyFlowScene
      };
      
      console.log('🔍 Scene imports:', sceneImports);
      
      // Check scene variables used in config
      console.log('🔍 Scene variables:');
      console.log('selectedBootScene:', typeof selectedBootScene, selectedBootScene?.name);
      console.log('selectedMainMenuScene:', typeof selectedMainMenuScene, selectedMainMenuScene?.name);
      console.log('selectedGuestMenuScene:', typeof selectedGuestMenuScene, selectedGuestMenuScene?.name);
      
      // Check feature flags
      const flags = {
        useDOMBoot: localStorage.getItem('pptHeroUseDOMBoot') === 'true',
        useDOMMenus: localStorage.getItem('pptHeroUseDOMMenus') === 'true',
        useUniversalLanding: localStorage.getItem('pptHeroUseUniversalLanding') === 'true',
        enableEnterpriseMobile: localStorage.getItem('enableEnterpriseMobile') === 'true'
      };
      console.log('🔍 Feature flags:', flags);
      
      return {
        gameExists: !!window.game,
        sceneManagerExists: !!window.game?.scene,
        registeredScenes: window.game?.scene?.keys || [],
        sceneInstances: window.game?.scene?.scenes?.map(s => s.scene.key) || [],
        sceneImports,
        flags
      };
    };
    
    // Add enterprise mobile scene force utility
    window.forceEnterpriseMobile = () => {
      console.log('🎯 FORCE loading enterprise mobile scene...');
      localStorage.setItem('enableEnterpriseMobile', 'true');
      window.forceSceneTransition('EnterpriseAuthenticatedMenuScene');
    };
    
    // REMOVED: Global scrolling fixes - this violates separation of concerns
    // Each scene should handle its own scrolling needs
    
    // EMERGENCY: Auto-detect white screen after 3 seconds
    setTimeout(() => {
      const activeScenes = window.game?.scene?.scenes?.filter(s => s.scene.isActive()) || [];
      const preloader = document.getElementById('preloader');
      const container = document.getElementById('game-container');
      
      if (activeScenes.length === 0 || (preloader && preloader.style.display !== 'none')) {
        console.warn('🚨 WHITE SCREEN DETECTED - Running emergency recovery');
        // DISABLED: Emergency recovery can interfere with template loading
        // window.emergencyRecovery();
        console.log('🔧 Emergency recovery disabled - template system handles display');
      }
    }, 3000);
    
    console.log('📱 Native mobile services initialized successfully');
    console.log('💡 Use window.testUnifiedMobile() for mobile debugging');
    console.log('🚨 Use window.diagnoseWhiteScreen() if you see a white screen');
    
  } catch (error) {
    console.error('❌ Error initializing unified mobile services:', error);
    
    // Provide fallback mobile support
    window.unifiedMobile = {
      isEnabled: false,
      error: error.message,
      getStatus: () => ({ error: error.message })
    };
  }
  
} else {
  console.log('💻 Desktop mode - mobile services not initialized');
  console.log(`📐 Screen: ${window.innerWidth}x${window.innerHeight}`);
  
  // ENTERPRISE: Ensure no mobile interference on desktop
  window.serviceLocator = new Map(); // Initialize service locator for desktop too
  window.serviceLocator.set('MobileDetectionService', MobileDetectionService);
  
  // CRITICAL: Make MobileDetectionService available globally for enterprise services
  window.MobileDetectionService = MobileDetectionService;
  
  // REMOVED: Desktop should NOT have unifiedMobile - maintains separation of concerns
  
  // Desktop-specific debug utilities
  window.debugDesktopMode = () => {
    console.log('🖥️ DESKTOP MODE VERIFICATION:');
    console.log('Mobile detected:', MobileDetectionService.isMobile());
    console.log('UnifiedMobileSystem running:', !!window.serviceLocator?.get('UnifiedMobileSystem'));
    console.log('Screen size:', `${window.innerWidth}x${window.innerHeight}`);
    console.log('Auth overlay exists:', !!document.getElementById('auth-overlay'));
    
    return {
      isMobile: MobileDetectionService.isMobile(),
      mobileSystemActive: !!window.serviceLocator?.get('UnifiedMobileSystem'),
      screenSize: `${window.innerWidth}x${window.innerHeight}`
    };
  };
  
  // ENTERPRISE: Initialize desktop authentication protection
  DesktopAuthProtection.initialize();
  
  console.log('✅ Desktop mode initialized with proper separation');
}

// --- Initialize Z-Index Management ---
window.addEventListener('load', () => {
  // Fix common z-index conflicts after page load
  setTimeout(() => {
    ZIndexManager.fixCommonConflicts();
    ZIndexManager.logLayerHierarchy();
    
    // Make ZIndexManager globally available for enterprise validation
    window.ZIndexManager = ZIndexManager;
    
    // Make authService globally available for enterprise validation
    window.authService = {
        signIn: (email, password) => auth.signInWithEmailAndPassword(email, password),
        signOut: () => auth.signOut(),
        getCurrentUser: () => auth.currentUser,
        onAuthStateChanged: (callback) => auth.onAuthStateChanged(callback)
    };
    
    // Make special access functions globally available for enterprise validation
    window.hasSpecialAccess = hasSpecialAccess;
    window.getSpecialAccessDisplayName = getSpecialAccessDisplayName;
    window.getSpecialAccessHoursRemaining = getSpecialAccessHoursRemaining;
    
    // CRITICAL: Ensure Firebase globals are available for validation
    // Import Firebase config to set window.auth and window.db early
    import('./firebaseConfig.js').then(() => {
      console.log('🔧 Firebase globals set for enterprise validation');
    }).catch(err => {
      console.warn('🔧 Firebase import for validation failed:', err);
    });
    
    // Audit for conflicts in development
    if (process.env.NODE_ENV !== 'production') {
      const conflicts = ZIndexManager.auditZIndexConflicts();
      if (conflicts.length > 0) {
        console.warn('⚠️ Z-Index conflicts detected:', conflicts);
      } else {
        console.log('✅ No z-index conflicts detected');
      }
    }
  }, 1000);
});

// --- Push Notification Support ---
function setupPushNotificationSupport() {
  // Only setup support, don't request permission yet
  console.log('🔔 Push notification support initialized (permission will be requested on user interaction)');
  
  // Make notification functions available globally for user-triggered requests
  window.requestNotificationPermission = requestNotificationPermission;
  window.showWelcomeNotification = showWelcomeNotification;
}

async function requestNotificationPermission() {
  try {
    // Only request permission when called by user interaction
    const permission = await Notification.requestPermission();
    
    if (permission === 'granted') {
      console.log('🔔 Push notifications enabled');
      
      // Schedule welcome notification after 5 minutes
      setTimeout(() => {
        showWelcomeNotification();
      }, 5 * 60 * 1000);
      
      // Schedule daily engagement notification
      scheduleDailyNotification();
      
      return true;
    } else {
      console.log('🚫 Push notifications denied');
      return false;
    }
  } catch (error) {
    console.error('❌ Failed to initialize push notifications:', error);
    return false;
  }
}

function showWelcomeNotification() {
  if (document.hidden) { // Only show if app is in background
    new Notification('Welcome to DeckOps.ai! 🚀', {
      body: 'Your executive performance journey continues. Ready for your next Philosophy Flow session?',
      icon: '/assets/icon-192.png',
      badge: '/assets/badge-icon.png',
      tag: 'welcome',
      requireInteraction: false,
      actions: [
        { action: 'open', title: 'Open App', icon: '/assets/open-icon.png' },
        { action: 'later', title: 'Remind Later', icon: '/assets/later-icon.png' }
      ]
    });
  }
}

function scheduleDailyNotification() {
  // Schedule notification for next day at 9 AM
  const now = new Date();
  const tomorrow9AM = new Date(now);
  tomorrow9AM.setDate(now.getDate() + 1);
  tomorrow9AM.setHours(9, 0, 0, 0);
  
  const timeUntilTomorrow9AM = tomorrow9AM.getTime() - now.getTime();
  
  setTimeout(() => {
    if (document.hidden) {
      new Notification('Daily Executive Challenge 💼', {
        body: 'Start your day with strategic thinking. New Philosophy Flow scenarios await!',
        icon: '/assets/icon-192.png',
        badge: '/assets/badge-icon.png',
        tag: 'daily',
        requireInteraction: true,
        actions: [
          { action: 'start', title: 'Start Session', icon: '/assets/start-icon.png' },
          { action: 'snooze', title: 'Snooze 1hr', icon: '/assets/snooze-icon.png' }
        ]
      });
    }
    
    // Reschedule for next day
    scheduleDailyNotification();
  }, timeUntilTomorrow9AM);
}

// --- Phaser Game Configuration ---
const isMobile = MobileDetectionService.isMobile();

// Mobile configuration updates from implementation guide
const mobileConfig = {
    type: Phaser.CANVAS, // Canvas renderer for consistent rendering
    scale: {
        mode: Phaser.Scale.RESIZE,
        parent: 'game-container',
        width: '100%',
        height: '100%',
        autoCenter: Phaser.Scale.CENTER_BOTH
    },
    render: {
        powerPreference: 'low-power', // Battery optimization
        batchSize: 1024, // Reduced for mobile
        clearBeforeRender: true
    },
    input: {
        touch: {
            target: null, // Use window
            capture: false // Allow scroll
        }
    },
    physics: {
        default: 'arcade',
        arcade: {
            fps: 30, // Reduced for mobile
            gravity: { y: 0 }
        }
    }
};

const config = {
  type: Phaser.CANVAS, // Canvas renderer for consistent rendering across devices
  backgroundColor: "#080818", // Consistent AI theme background throughout entire application
  parent: "game-container",
  // CRITICAL: Enable DOM support for Phaser DOM elements
  dom: {
    createContainer: true
  },
  input: {
    mouse: {
      target: null // Allow window-level mouse events
    },
    touch: {
      target: null, // CRITICAL: Use window target to allow DOM scrolling
      capture: false // Never capture to allow DOM events
    },
    activePointers: 3, 
    smoothFactor: 0.2
  },
        scale: {
          mode: Phaser.Scale.RESIZE,
          parent: 'game-container',
          width: '100%',
          height: '100%',
          autoCenter: Phaser.Scale.CENTER_BOTH,
        },
  render: {
    pixelArt: false, antialias: true, transparent: false,
    powerPreference: isMobile ? "low-power" : "high-performance", // Battery optimization
    batchSize: isMobile ? 1024 : 2048, clearBeforeRender: true, // Reduced for mobile
    roundPixels: window.devicePixelRatio > 1
  },
  physics: {
    default: "arcade",
    arcade: {
      gravity: { y: 0 }, debug: false,
      fps: isMobile ? 30 : 60, timeScale: 1, // Reduced FPS for mobile
      skipQuadTree: false, overlapBias: isMobile ? 8 : 4, tileBias: isMobile ? 32 : 16
    }
  },
  plugins: {
    scene: [{
      key: 'rexUI',
      plugin: RexUIPlugin,
      mapping: 'rexUI'
    }]
  },
  scene: [ 
    selectedBootScene, // Always BootSceneDOM
    selectedMainMenuScene, // Feature flag determines main menu scene
    ...(selectedGuestMenuScene ? [selectedGuestMenuScene] : []), // Only add if not using universal landing
    // Auth menu scene selection based on feature flags
    ...(useDOMAuthMenu ? [AuthenticatedMenuSceneDOM] : [AuthenticatedMenuScene]),
    // Enterprise mobile scenes (always available for mobile routing)
    EnterpriseAuthenticatedMenuScene,
    EnterprisePhilosophyFlowScene,
    // Full-page authentication scenes
    SignInSceneDOM,
    SignUpSceneDOM,
    ProfileScene, 
    ProfileSceneDOM, 
    // Re-enabling template scenes - navigation buttons need these
    ProfileSceneDOMTemplate,
    MyLibrarySceneDOM,
    NotificationsSceneDOM,
    PasswordResetSceneDOM,
    GameCenterSceneDOM,
    AnalyticsSceneDOM,
    AdminPanelSceneDOM,
    CompanyVerificationSceneDOM,
    PhilosophyFlowSceneDOM,
        PhilosophyFlowDesktopScene,
        HallOfFameSceneTemplate,
        HallOfFameSceneTemplateBeautiful,
        HallOfFameDesktopTemplate,
    ProfileLoadingScene,
    // Game scenes (required for dynamic starting, but UI creation delayed)
    PPTHeroScene, 
    PPTHeroGenericScene, 
    PPTHeroBainScene,
    GameScene, 
    MultiplayerMenuScene, 
    CreateGameScene, 
    JoinGameScene, 
    LobbyScene, 
    MultiplayerGameScene, 
    MultiplayerGameOverScene, 
    AdminConsoleScene, 
    PhilosophyFlowScene,
    ClassifyScene, 
    ClassifyTechGameOverScene,
    
    // Register backup menu scenes
    ...(useUniversalLanding ? 
        [MainMenuScene, MainMenuSceneDOM, GuestMenuScene, GuestMenuSceneDOM] : 
        (useDOMMenus ? [MainMenuScene, GuestMenuScene] : [MainMenuSceneDOM, GuestMenuSceneDOM, MainMenuSceneUniversal])
    ),
    ...(useDOMAuthMenu ? [AuthenticatedMenuScene] : [AuthenticatedMenuSceneDOM])
  ],

  audio: { 
    disableWebAudio: isMobileDevice, // Disable WebAudio on mobile to prevent context.resume errors
    noAudio: false
  },
  // Rex UI will be loaded per-scene using scene.load.scenePlugin
  callbacks: {
    postBoot: function(game) {
      console.log(`Phaser Game Booted. Version: ${window.PROJECT_VERSION}`);
      window.dispatchEvent(new Event('resize')); // Initial resize trigger

      // --- Initialize SceneManager HERE ---
      sceneManager.init(game);
      window.sceneManager = sceneManager; // Optional: Expose globally
      console.log("SceneManager initialized in postBoot.");
      // --- END SceneManager Init ---

      // --- Initialize UI Controller HERE ---
      window.UIController = UIController;
      UIController.init(); // Initialize UI Controller after Phaser boot
      console.log("UIController initialized in postBoot.");
      // --- END UI Controller Init ---

      // --- REGISTER FIREBASE LISTENER HERE ---
      console.log('>>> Phaser postBoot: Attempting to register Firebase auth listener...');
      if (!authListenerRegistered && auth && typeof auth.onAuthStateChanged === 'function') {
          try {
              // Define the listener function separately for clarity
              const firebaseAuthStateListener = async (user) => {
                  console.log(`>>> Firebase onAuthStateChanged TRIGGERED with user: ${user ? user.uid : 'null'}`);
                  try {
                      // Ensure SceneManager is ready before handling auth state
                      if (!sceneManager.gameInstance) {
                           console.warn("Auth listener triggered, but SceneManager not ready. Delaying logic.");
                           await new Promise(resolve => setTimeout(resolve, 500)); // Wait a bit
                      }
                      await handleAuthStateChangeLogic(user); // Call the reusable logic
                  } catch (error) {
                      console.error("Error inside firebaseAuthStateListener's call to handleAuthStateChangeLogic:", error);
                  }
              };

              const unsubscribe = auth.onAuthStateChanged(firebaseAuthStateListener);
              authListenerRegistered = true; // Set flag
              console.log('>>> Firebase auth listener registered successfully in postBoot.');
              // Optional: window.authUnsubscribe = unsubscribe;

              // --- PERFORM INITIAL AUTH CHECK *AFTER* REGISTRATION ---
              console.log(">>> Performing initial auth check after listener registration...");
              // Run logic immediately with current state, but ensure SceneManager is ready first
              if (!sceneManager.gameInstance) {
                   console.warn("Initial auth check delayed: SceneManager not ready.");
                   setTimeout(() => handleAuthStateChangeLogic(auth.currentUser), 500);
              } else {
                   handleAuthStateChangeLogic(auth.currentUser);
              }
              // --- END INITIAL CHECK ---

          } catch (registrationError) {
              console.error(">>> CRITICAL: Error DURING auth.onAuthStateChanged registration in postBoot:", registrationError);
              handleAuthStateChangeLogic(null); // Assume logged out on registration failure
          }
      } else if (authListenerRegistered) {
           console.warn(">>> Firebase auth listener already registered.");
      } else {
          console.error(">>> CRITICAL: Cannot register Firebase auth listener in postBoot - auth object or method invalid!");
          handleAuthStateChangeLogic(null); // Assume logged out
      }
      // --- END FIREBASE LISTENER REGISTRATION ---

      // iOS audio unlock (keep as is)
      if (game.device.os.iOS && game.sound?.locked) { /* ... */ }

      // Set up auth event listeners for UI elements AFTER UIController is initialized
      setupAuthEventListeners();
      console.log("Auth UI event listeners set up in postBoot.");
      
        // Enterprise services are now statically imported and bundled
        
        // Rex UI will be loaded per-scene - check global availability
      if (window.RexPlugins && window.RexPlugins.UI) {
        console.log("✅ Rex UI available globally - will be loaded per-scene");
        console.log("Available Rex UI components:", Object.keys(window.RexPlugins.UI));
      } else {
        console.error("❌ Rex UI not available globally");
      }
  }
}
};

    // --- Initialize Game Instance ---
    console.log('🔍 DEBUGGING: About to create Phaser game instance...');
    console.log('🔍 DEBUGGING: Config object:', config);
    console.log('🔍 DEBUGGING: Game container exists:', !!document.getElementById('game-container'));
    
    try {
        console.log('🔍 DEBUGGING: Creating new Phaser.Game...');
        console.log('🔍 DEBUGGING: Phaser version:', Phaser.VERSION);
        console.log('🔍 DEBUGGING: Config scenes:', config.scene.map(s => s.name || s.constructor.name));
        
        window.gameInstance = new Phaser.Game(config);
        window.game = window.gameInstance; // CRITICAL FIX: Ensure consistency
        
        if (window.gameInstance) {
            console.log("✅ DEBUGGING: Phaser Game instance created successfully!");
            console.log('🔍 DEBUGGING: Game instance type:', typeof window.gameInstance);
            console.log('🔍 DEBUGGING: Game instance constructor:', window.gameInstance.constructor.name);
            console.log('🔍 DEBUGGING: window.game alias set:', !!window.game);
            
            // SceneManager will be initialized in postBoot callback - don't duplicate
            console.log("✅ DEBUGGING: Waiting for postBoot to initialize SceneManager...");

            window.gameInstance.getActiveScene = function() {
                try {
                     return sceneManager.getActiveSceneInstance();
                } catch (error) { console.error("Error in getActiveScene:", error); 
                    return null; }
            };
            
            console.log("✅ DEBUGGING: Game instance setup complete - should progress past boot now!");
        } else {
            console.error("🚨 DEBUGGING: Phaser.Game returned null/undefined");
        }
    } catch (error) {
        console.error("🚨 CRITICAL: Error creating Phaser game instance:", error);
        console.error("🚨 DEBUGGING: Error details:", error.message);
        console.error("🚨 DEBUGGING: Error stack:", error.stack);
        console.error("🚨 DEBUGGING: Config that failed:", config);
        
        // Create emergency fallback
        document.getElementById('game-container').innerHTML = `
            <div style="color:red; padding: 20px; background: #0f172a; height: 100vh;">
                <h2>🚨 Phaser Initialization Failed</h2>
                <p>Error: ${error.message}</p>
                <button onclick="window.location.reload()" style="background: #00d4ff; color: white; border: none; padding: 10px 20px; border-radius: 5px; margin-top: 10px;">
                    Refresh Page
                </button>
            </div>
        `;
    }

// --- Global Canvas Fix Function ---
window.fixCanvasDisplay = () => { CanvasFixer.fixCanvas(); window.dispatchEvent(new Event('resize')); };
window.CanvasFixer = CanvasFixer; // Expose for debugging

// --- DOM Ready Initialization ---
document.addEventListener('DOMContentLoaded', () => {
    console.log("DOM Ready: Initializing non-Phaser UI and services.");
    try {
        // UIController is initialized in postBoot now
        cookieManager.init();
        sessionManager.init();
        CanvasFixer.startMonitoring();
        setupRibbonListeners(); // Setup ribbon listeners
        updateVersionDisplay(); // Show version in ribbon
        
        // Check for special access and set up notifications
        checkSpecialAccessOnStartup();
        
        // Initialize iOS PWA detection
        detectiOSPWA();
        
        // Add utility method for global message display
        if (!window.showGeneralMessage && typeof showGeneralMessage === 'function') {
            window.showGeneralMessage = showGeneralMessage;
        }
        
        console.info('Dev Console: Use window.UIController or window.fixCanvasDisplay() for UI issues.');
        
        // Track app initialization for Vercel Analytics
        if (window.va && typeof window.va.track === 'function') {
            window.va.track('app_initialized', {
                deviceType: isMobileDevice ? 'mobile' : 'desktop',
                version: window.PROJECT_VERSION
            });
        }
    } catch (error) {
        console.error("Error during DOMContentLoaded initialization:", error);
    }
});

function updateVersionDisplay() {
    const versionDisplay = document.getElementById("project-version-display");
    if (versionDisplay) {
        versionDisplay.textContent = `v${window.PROJECT_VERSION || '?'}`;
    }
}
// Add this to index.js
// Create a global helper function to reset transition flags
window.fixTransitionState = function() {
    console.log("Manually resetting transition flags");
    
    // Reset global flags
    window.sceneTransitionInProgress = false;
    window.sceneTransitionStartTime = null;
    
    if (window.sceneTransitionClearTimeout) {
        clearTimeout(window.sceneTransitionClearTimeout);
        window.sceneTransitionClearTimeout = null;
    }
    
    // Reset local flags in all known scenes
    const allScenes = window.gameInstance?.scene?.scenes || [];
    if (allScenes.length > 0) {
        allScenes.forEach(scene => {
            if (scene.isTransitioning) {
                console.log(`Resetting isTransitioning flag on ${scene.scene.key}`);
                scene.isTransitioning = false;
            }
        });
    }
    
    // Reset current active scene
    const currentScene = window.gameInstance?.getActiveScene?.();
    if (currentScene) {
        console.log(`Ensuring current scene ${currentScene.scene.key} has transition reset`);
        currentScene.isTransitioning = false;
        
        // Ensure input is enabled
        if (currentScene.input && !currentScene.input.enabled) {
            currentScene.input.enabled = true;
        }
    }
    
    // Let UIController try to fix input
    if (window.UIController) {
        window.UIController.enableSceneInput();
    }
    
    return "Transition flags reset";
};

// Log instructions
console.log("If scene transitions get stuck, run window.fixTransitionState() in console");

// DIAGNOSTIC: Global function to debug authentication routing
window.debugAuthRouting = function() {
    const user = auth.currentUser;
    const specialAccess = typeof hasSpecialAccess === 'function' ? hasSpecialAccess() : false;
    const isEffectivelyLoggedIn = (user && user.emailVerified) || specialAccess;
    const currentScene = window.gameInstance?.getActiveScene?.();
    const currentSceneKey = currentScene?.scene?.key || 'none';
    
    const featureFlags = {
        useUniversalLanding: localStorage.getItem('pptHeroUseUniversalLanding') === 'true',
        useDOMMenus: localStorage.getItem('pptHeroUseDOMMenus') === 'true',
        useDOMAuthMenu: localStorage.getItem('pptHeroUseDOMAuthMenu') === 'true',
        useDOMProfile: localStorage.getItem('pptHeroUseDOMProfile') === 'true'
    };
    
    console.log('🔍 AUTHENTICATION ROUTING DEBUG:', {
        user: {
            email: user?.email || 'none',
            emailVerified: user?.emailVerified || false,
            uid: user?.uid || 'none'
        },
        specialAccess,
        isEffectivelyLoggedIn,
        currentSceneKey,
        featureFlags,
        expectedAuthMenu: isEffectivelyLoggedIn ? (featureFlags.useDOMAuthMenu ? 'AuthenticatedMenuSceneDOM' : 'AuthenticatedMenuScene') : 'N/A'
    });
    
    return 'Debug info logged above';
};
console.log("Debug authentication routing with: window.debugAuthRouting()");

// DIAGNOSTIC: Global function to test profile button functionality
window.testProfileButton = function() {
    const user = auth.currentUser;
    const useDOMProfile = localStorage.getItem('pptHeroUseDOMProfile') === 'true';
    const targetScene = useDOMProfile ? "ProfileSceneDOM" : "ProfileLoadingScene";
    
    console.log('🔍 PROFILE BUTTON TEST:', {
        userAuthenticated: !!user,
        userEmail: user?.email || 'none',
        useDOMProfile,
        targetScene,
        sceneManagerAvailable: !!window.sceneManager
    });
    
    if (user) {
        console.log('🔍 Testing profile scene transition...');
        if (window.sceneManager) {
            window.sceneManager.switchToScene(targetScene);
        } else {
            console.error('SceneManager not available for profile test');
        }
    } else {
        console.warn('No authenticated user for profile test');
    }
    
    return 'Profile test executed - check logs above';
};
console.log("Test profile button with: window.testProfileButton()");

// PROFESSIONAL USER EXPERIENCE: Ensure authenticated users never see guest interfaces
window.verifyAuthenticatedUserExperience = function() {
    const user = auth.currentUser;
    const specialAccess = typeof hasSpecialAccess === 'function' ? hasSpecialAccess() : false;
    const isEffectivelyLoggedIn = (user && user.emailVerified) || specialAccess;
    const currentScene = window.gameInstance?.getActiveScene?.();
    const currentSceneKey = currentScene?.scene?.key || 'none';
    
    const guestOnlyScenes = ["MainMenuScene", "GuestMenuScene", "MainMenuSceneDOM", "GuestMenuSceneDOM", "MainMenuSceneUniversal"];
    const isInGuestScene = guestOnlyScenes.includes(currentSceneKey);
    
    console.log('🔐 AUTHENTICATION VERIFICATION:', {
        user: {
            email: user?.email || 'none',
            emailVerified: user?.emailVerified || false,
            uid: user?.uid || 'none'
        },
        specialAccess,
        isEffectivelyLoggedIn,
        currentSceneKey,
        isInGuestScene,
        shouldBeInAuthScene: isEffectivelyLoggedIn && isInGuestScene
    });
    
    // CRITICAL CHECK: If authenticated user is in guest scene, redirect immediately
    if (isEffectivelyLoggedIn && isInGuestScene) {
        console.error(`🚨 AUTHENTICATION VIOLATION: Authenticated user in guest scene (${currentSceneKey})`);
        
        // Use proper enterprise mobile routing
        const baseAuthScene = localStorage.getItem('pptHeroUseDOMAuthMenu') === 'true' ? "AuthenticatedMenuSceneDOM" : "AuthenticatedMenuScene";
        const targetScene = (enableEnterpriseMobile && isMobileDevice) ? "EnterpriseAuthenticatedMenuScene" : baseAuthScene;
        
        console.log(`🔐 CORRECTIVE ACTION: Redirecting to ${targetScene}`);
        
        if (window.sceneManager) {
            window.sceneManager.switchToScene(targetScene);
        } else if (window.gameInstance?.scene) {
            window.gameInstance.scene.start(targetScene);
        }
        
        return `CORRECTED: Redirected authenticated user from ${currentSceneKey} to ${targetScene}`;
    }
    
    if (isEffectivelyLoggedIn && !isInGuestScene) {
        return `✅ CORRECT: Authenticated user properly in ${currentSceneKey}`;
    }
    
    if (!isEffectivelyLoggedIn && isInGuestScene) {
        return `✅ CORRECT: Guest user properly in ${currentSceneKey}`;
    }
    
    return `✅ Authentication state verified`;
};
console.log("Verify auth experience with: window.verifyAuthenticatedUserExperience()");

// PROFESSIONAL EXPERIENCE: Periodic verification that authenticated users stay in authenticated areas
let authExperienceInterval = null;

window.startAuthenticatedUserProtection = function() {
    if (authExperienceInterval) {
        clearInterval(authExperienceInterval);
    }
    
    authExperienceInterval = setInterval(() => {
        try {
            const user = auth.currentUser;
            const specialAccess = typeof hasSpecialAccess === 'function' ? hasSpecialAccess() : false;
            const isEffectivelyLoggedIn = (user && user.emailVerified) || specialAccess;
            const currentScene = window.gameInstance?.getActiveScene?.();
            const currentSceneKey = currentScene?.scene?.key || 'none';
            
            // CRITICAL FIX: Only protect against true guest-only scenes, NOT Universal Landing
            const strictGuestOnlyScenes = ["GuestMenuScene", "GuestMenuSceneDOM"];
            const isInStrictGuestScene = strictGuestOnlyScenes.includes(currentSceneKey);
            
            // CRITICAL: Only redirect if authenticated user is in STRICT guest scenes (not Universal Landing)
            if (isEffectivelyLoggedIn && isInStrictGuestScene) {
                console.warn(`🚨 AUTHENTICATED USER PROTECTION: Redirecting from strict guest scene ${currentSceneKey}`);
                
                const useDOMAuthMenu = localStorage.getItem('pptHeroUseDOMAuthMenu') === 'true';
                const targetScene = useDOMAuthMenu ? "AuthenticatedMenuSceneDOM" : "AuthenticatedMenuScene";
                
                // Use SceneManager for professional transition
                if (window.sceneManager && !window.sceneManager.isTransitioning) {
                    window.sceneManager.switchToScene(targetScene);
                }
            }
        } catch (error) {
            console.warn('Authentication protection check error:', error);
        }
    }, 2000); // Check every 2 seconds
    
    console.log('🔐 Authenticated user protection started (checks every 2s)');
    return 'Protection active';
};

window.stopAuthenticatedUserProtection = function() {
    if (authExperienceInterval) {
        clearInterval(authExperienceInterval);
        authExperienceInterval = null;
        console.log('🔐 Authenticated user protection stopped');
        return 'Protection stopped';
    }
    return 'Protection not active';
};

// Start protection automatically  
setTimeout(() => {
    window.startAuthenticatedUserProtection();
}, 5000); // Start after initial boot sequence
console.log("Authentication protection available: window.startAuthenticatedUserProtection()");

// GUEST USER FLOW DEBUGGING TOOL
window.debugGuestUserFlow = function() {
    const user = auth.currentUser;
    const specialAccess = typeof hasSpecialAccess === 'function' ? hasSpecialAccess() : false;
    const isEffectivelyLoggedIn = (user && user.emailVerified) || specialAccess;
    const currentScene = window.gameInstance?.getActiveScene?.();
    const currentSceneKey = currentScene?.scene?.key || 'none';
    
    const sceneReadiness = {
        sceneReady: currentScene?.sceneReady || false,
        eventListenersAttached: currentScene?.eventListenersAttached || false,
        inputEnabled: currentScene?.input?.enabled || false,
        isTransitioning: currentScene?.isTransitioning || false
    };
    
    const sceneManagerState = {
        isTransitioning: window.sceneManager?.isTransitioning || false,
        currentSceneKey: window.sceneManager?.currentSceneKey || 'none',
        transitionCooldown: window.sceneManager?.transitionCooldown || false
    };
    
    console.log('🔍 GUEST USER FLOW DEBUG:', {
        user: {
            authenticated: !!user,
            emailVerified: user?.emailVerified || false,
            isGuest: !user
        },
        specialAccess,
        isEffectivelyLoggedIn,
        currentSceneKey,
        sceneReadiness,
        sceneManagerState,
        featureFlags: {
            useUniversalLanding: localStorage.getItem('pptHeroUseUniversalLanding') === 'true',
            useDOMMenus: localStorage.getItem('pptHeroUseDOMMenus') === 'true'
        }
    });
    
    // Test if scene can handle game clicks
    if (currentScene && typeof currentScene.handleGameAction === 'function') {
        console.log('🔍 Scene can handle game actions');
    } else {
        console.warn('🚨 Scene cannot handle game actions!');
    }
    
    return 'Guest user flow debug info logged above';
};
console.log("Debug guest user flow with: window.debugGuestUserFlow()");

// CLEAR LOCAL STORAGE HELPER
window.clearProjectLocalStorage = function() {
    const projectKeys = Object.keys(localStorage).filter(key => 
        key.includes('pptHero') || 
        key.includes('DeckOps') || 
        key.includes('ProjectAAA') ||
        key.includes('auth') ||
        key.includes('session')
    );
    
    console.log('🧹 Clearing project local storage keys:', projectKeys);
    projectKeys.forEach(key => localStorage.removeItem(key));
    
    // Reset to default values
    localStorage.setItem('pptHeroUseDOMBoot', 'false');
    localStorage.setItem('pptHeroUseDOMMenus', 'true');
    localStorage.setItem('pptHeroUseDOMAuthMenu', 'true');
    localStorage.setItem('pptHeroUseDOMProfile', 'true');
    localStorage.setItem('pptHeroUseUniversalLanding', 'true');
    localStorage.setItem('pptHeroUseNewAnalytics', 'true');
    localStorage.setItem('pptHeroUseDOMHallOfFame', 'true');
    
    console.log('🧹 Project local storage cleared and reset to defaults');
    console.log('🔄 Refresh page to apply changes');
    
    return 'Local storage cleared - refresh page to apply';
};
console.log("Clear local storage with: window.clearProjectLocalStorage()");

// GUEST USER FLOW FIXER
window.fixGuestUserFlow = function() {
    console.log('🔧 Attempting to fix guest user flow...');
    
    const currentScene = window.gameInstance?.getActiveScene?.();
    const currentSceneKey = currentScene?.scene?.key || 'none';
    
    // Reset scene transition flags
    if (typeof window.fixTransitionState === 'function') {
        window.fixTransitionState();
        console.log('🔧 Transition state flags reset');
    }
    
    // Reset scene readiness if current scene supports it
    if (currentScene) {
        if (typeof currentScene.sceneReady !== 'undefined') {
            currentScene.sceneReady = true;
            console.log('🔧 Scene readiness flag set to true');
        }
        
        if (typeof currentScene.eventListenersAttached !== 'undefined') {
            currentScene.eventListenersAttached = true;
            console.log('🔧 Event listeners marked as attached');
        }
        
        // Enable input if it exists
        if (currentScene.input && typeof currentScene.input.enabled !== 'undefined') {
            currentScene.input.enabled = true;
            console.log('🔧 Scene input enabled');
        }
    }
    
    // Enable UI Controller input
    if (window.UIController && typeof window.UIController.enableSceneInput === 'function') {
        window.UIController.enableSceneInput();
        console.log('🔧 UIController input enabled');
    }
    
    console.log(`🔧 Guest flow fix applied to scene: ${currentSceneKey}`);
    
    return 'Guest user flow fix applied - try clicking games now';
};
console.log("Fix guest flow with: window.fixGuestUserFlow()");

// UNIVERSAL LANDING PAGE EVENT FIXER
window.fixUniversalLandingEvents = function() {
    console.log('🔧 Fixing Universal Landing Page event listeners...');
    
    const gameCardConfigs = [
        { id: 'pptHeroCard', game: 'ppt-hero' },
        { id: 'slideWarsCard', game: 'slide-wars' }, 
        { id: 'philosophyFlowCard', game: 'philosophy-flow' },
        { id: 'classifyTechCard', game: 'classify-tech' }
    ];
    
    let fixedCount = 0;
    
    gameCardConfigs.forEach(config => {
        const card = document.getElementById(config.id);
        if (card) {
            // Force set onclick handler
            card.onclick = (e) => {
                e.preventDefault();
                e.stopPropagation();
                console.log(`🎮 Manual fix: Game card clicked - ${config.id}`);
                
                const currentScene = window.gameInstance?.getActiveScene?.();
                if (currentScene && currentScene.playGame) {
                    if (config.game === 'slide-wars') {
                        currentScene.showSignUpPrompt('slide-wars');
                    } else {
                        currentScene.playGame(config.game);
                    }
                } else {
                    console.error('Current scene or playGame method not available');
                }
            };
            
            // Also set CSS cursor to pointer to indicate clickability
            card.style.cursor = 'pointer';
            
            fixedCount++;
            console.log(`✅ Fixed event listener for ${config.id}`);
        } else {
            console.warn(`❌ Game card ${config.id} not found`);
        }
    });
    
    console.log(`🔧 Fixed ${fixedCount}/${gameCardConfigs.length} game card event listeners`);
    
    return `Fixed ${fixedCount} game card event listeners - try clicking games now`;
};
console.log("Fix Universal Landing events with: window.fixUniversalLandingEvents()");

// TEST GAME CARD CLICKS
window.testGameCardClicks = function() {
    console.log('🧪 Testing game card click functionality...');
    
    const gameCards = ['pptHeroCard', 'slideWarsCard', 'philosophyFlowCard', 'classifyTechCard'];
    let results = {};
    
    gameCards.forEach(cardId => {
        const card = document.getElementById(cardId);
        if (card) {
            results[cardId] = {
                found: true,
                hasOnclick: !!card.onclick,
                visible: getComputedStyle(card).display !== 'none',
                clickable: card.style.cursor === 'pointer' || getComputedStyle(card).cursor === 'pointer'
            };
            
            // Test click programmatically
            try {
                if (card.onclick) {
                    console.log(`🧪 Testing programmatic click on ${cardId}...`);
                    card.click();
                } else {
                    console.warn(`⚠️ ${cardId} has no onclick handler`);
                }
            } catch (error) {
                console.error(`❌ Error testing ${cardId} click:`, error);
                results[cardId].clickError = error.message;
            }
        } else {
            results[cardId] = { found: false };
        }
    });
    
    console.log('🧪 Game card click test results:', results);
    
    return results;
};
console.log("Test game cards with: window.testGameCardClicks()");

// COMPREHENSIVE NAVIGATION TEST SUITE
import('./utils/NavigationTestSuite.js').then(module => {
    window.NavigationTestSuite = module.NavigationTestSuite;
    window.testAllNavigation = module.testNavigation;
    console.log("🧪 COMPLETE NAVIGATION TEST: window.testAllNavigation()");
}).catch(err => console.error('Failed to load NavigationTestSuite:', err));

// EXECUTIVE LOADING EXPERIENCE DIAGNOSTIC
window.analyzeLoadingExperience = function() {
    console.log('🏢 Analyzing Executive Loading Experience...');
    
    const preloader = document.getElementById('preloader');
    const gameContainer = document.getElementById('game-container');
    const bootDOMOverlay = document.getElementById('boot-dom-overlay');
    const universalMenuOverlay = document.getElementById('main-menu-universal-overlay');
    
    const loadingExperience = {
        htmlPreloader: {
            present: !!preloader,
            visible: preloader ? getComputedStyle(preloader).display !== 'none' : false,
            opacity: preloader ? getComputedStyle(preloader).opacity : 'N/A',
            fadeOutClass: preloader ? preloader.classList.contains('fade-out') : false
        },
        gameContainer: {
            present: !!gameContainer,
            visibility: gameContainer ? getComputedStyle(gameContainer).visibility : 'N/A',
            display: gameContainer ? getComputedStyle(gameContainer).display : 'N/A'
        },
        bootSceneDOM: {
            present: !!bootDOMOverlay,
            visible: bootDOMOverlay ? getComputedStyle(bootDOMOverlay).display !== 'none' : false
        },
        universalMenu: {
            present: !!universalMenuOverlay,
            visible: universalMenuOverlay ? getComputedStyle(universalMenuOverlay).display !== 'none' : false
        },
        currentPhase: 'unknown'
    };
    
    // Determine current loading phase
    if (loadingExperience.htmlPreloader.visible && !loadingExperience.htmlPreloader.fadeOutClass) {
        loadingExperience.currentPhase = '1. HTML Preloader (Pre-Boot)';
    } else if (loadingExperience.bootSceneDOM.visible) {
        loadingExperience.currentPhase = '2. BootSceneDOM (Professional Loading)';
    } else if (loadingExperience.universalMenu.visible) {
        loadingExperience.currentPhase = '3. Universal Landing Page (Application)';
    } else {
        loadingExperience.currentPhase = '4. Game/Application Running';
    }
    
    console.log('🏢 Executive Loading Experience Analysis:', loadingExperience);
    
    // Professional UX Assessment
    const uxAssessment = {
        isOptimal: !loadingExperience.htmlPreloader.visible || loadingExperience.bootSceneDOM.visible,
        hasDoubleLoading: loadingExperience.htmlPreloader.visible && loadingExperience.bootSceneDOM.present,
        professionalBranding: true, // Now matches BootSceneDOM
        recommendations: []
    };
    
    if (uxAssessment.hasDoubleLoading) {
        uxAssessment.recommendations.push('Consider faster transition between HTML preloader and BootSceneDOM');
    }
    
    if (!uxAssessment.isOptimal) {
        uxAssessment.recommendations.push('HTML preloader should fade out quickly when BootSceneDOM loads');
    }
    
    console.log('🏢 Executive UX Assessment:', uxAssessment);
    
    return {
        loadingExperience,
        uxAssessment,
        phase: loadingExperience.currentPhase
    };
};
console.log("Analyze loading experience with: window.analyzeLoadingExperience()");

// LOADING EXPERIENCE OPTIMIZER
window.optimizeLoadingTransition = function() {
    console.log('🏢 Optimizing executive loading transition...');
    
    const preloader = document.getElementById('preloader');
    const bootDOMOverlay = document.getElementById('boot-dom-overlay');
    
    if (preloader && bootDOMOverlay) {
        console.log('🏢 Both preloader and BootSceneDOM detected - forcing optimal transition');
        
        // Force hide HTML preloader immediately when BootSceneDOM is active
        preloader.style.opacity = '0';
        preloader.style.pointerEvents = 'none';
        
        setTimeout(() => {
            preloader.remove();
            console.log('🏢 HTML preloader removed - BootSceneDOM now primary');
        }, 200);
        
        return 'Loading transition optimized - HTML preloader removed';
    }
    
    if (preloader && !bootDOMOverlay) {
        console.log('🏢 Only HTML preloader active - normal flow');
        return 'HTML preloader active - waiting for BootSceneDOM';
    }
    
    if (!preloader && bootDOMOverlay) {
        console.log('✅ Optimal state - Only BootSceneDOM loading active');
        return 'Optimal loading state achieved';
    }
    
    console.log('🏢 No loading screens detected - application running');
    return 'Application fully loaded';
};
console.log("Optimize loading with: window.optimizeLoadingTransition()");

// COMPREHENSIVE DATA FLOW DEBUGGING FOR AUTHENTICATION ISSUES
window.debugDataFlowAuthentication = function() {
    console.log('🔍 ===== COMPREHENSIVE DATA FLOW AUTHENTICATION DEBUG =====');
    
    const user = auth.currentUser;
    const specialAccess = typeof hasSpecialAccess === 'function' ? hasSpecialAccess() : false;
    const isEffectivelyLoggedIn = (user && user.emailVerified) || specialAccess;
    const currentScene = window.gameInstance?.getActiveScene?.();
    const currentSceneKey = currentScene?.scene?.key || 'none';
    
    // 1. AUTHENTICATION STATE
    console.log('🔐 AUTHENTICATION STATE:', {
        user: {
            exists: !!user,
            uid: user?.uid || 'none',
            email: user?.email || 'none', 
            emailVerified: user?.emailVerified || false,
            displayName: user?.displayName || 'none'
        },
        specialAccess,
        isEffectivelyLoggedIn,
        authCurrentUser: !!auth.currentUser
    });
    
    // 2. SCENE STATE
    console.log('🎬 SCENE STATE:', {
        currentSceneKey,
        sceneManager: {
            currentSceneKey: window.sceneManager?.currentSceneKey || 'none',
            isTransitioning: window.sceneManager?.isTransitioning || false
        },
        sceneInstance: {
            exists: !!currentScene,
            sceneReady: currentScene?.sceneReady || false,
            eventListenersAttached: currentScene?.eventListenersAttached || false,
            inputEnabled: currentScene?.input?.enabled || false
        }
    });
    
    // 3. DATA STORAGE STATE
    const localStorageData = {
        pptHeroScores: localStorage.getItem('pptHeroUnifiedScores'),
        authTokens: Object.keys(localStorage).filter(k => k.includes('auth') || k.includes('firebase')),
        sessionData: Object.keys(localStorage).filter(k => k.includes('session')),
        featureFlags: {
            useDOMProfile: localStorage.getItem('pptHeroUseDOMProfile'),
            useDOMAuthMenu: localStorage.getItem('pptHeroUseDOMAuthMenu'),
            useUniversalLanding: localStorage.getItem('pptHeroUseUniversalLanding')
        }
    };
    
    console.log('💾 DATA STORAGE STATE:', {
        localStorage: {
            totalKeys: Object.keys(localStorage).length,
            hasPPTHeroScores: !!localStorageData.pptHeroScores,
            authRelatedKeys: localStorageData.authTokens.length,
            sessionKeys: localStorageData.sessionData.length,
            featureFlags: localStorageData.featureFlags
        },
        firebase: {
            authAvailable: !!auth,
            currentUserExists: !!auth.currentUser,
            dbAvailable: !!db
        }
    });
    
    // 4. PPT HERO DATA STATE (if in PPT Hero)
    if (currentSceneKey.includes('PPTHero')) {
        console.log('🎯 PPT HERO DATA STATE:', {
            scoreStorageManager: !!currentScene?.scoreStorageManager,
            userProfile: currentScene?.userProfile || 'none',
            scoreData: currentScene?.scoreStorageManager?.scoreData ? 'loaded' : 'not loaded',
            roundProgress: currentScene?.roundProgress || 'none'
        });
    }
    
    // 5. PROFILE SCENE READINESS (if attempting profile access)
    if (currentSceneKey.includes('Profile') || isEffectivelyLoggedIn) {
        console.log('👤 PROFILE ACCESS STATE:', {
            authCurrentUser: !!auth.currentUser,
            profileSceneExists: !!window.gameInstance?.scene?.getScene('ProfileSceneDOM'),
            canAccessProfile: isEffectivelyLoggedIn
        });
        
        // Test profile data loading capability
        if (user) {
            console.log('🧪 Testing profile data access...');
            db.collection("userProfiles").doc(user.uid).get().then(doc => {
                console.log('✅ Profile data access test:', doc.exists ? 'SUCCESS' : 'NO PROFILE DOC');
            }).catch(error => {
                console.error('❌ Profile data access test FAILED:', error);
            });
        }
    }
    
    return 'Comprehensive authentication and data flow debug completed - check logs above';
};
console.log("Debug data flow & auth with: window.debugDataFlowAuthentication()");

// GUEST DATA CLEANING TOOL
window.cleanGuestDataLeakage = function() {
    console.log('🧹 Cleaning potential guest data leakage...');
    
    // Clear all PPT Hero related localStorage for clean state
    const pptHeroKeys = Object.keys(localStorage).filter(key => key.includes('pptHero'));
    console.log('🧹 Found PPT Hero localStorage keys:', pptHeroKeys);
    
    pptHeroKeys.forEach(key => {
        const data = localStorage.getItem(key);
        console.log(`🧹 Removing ${key}:`, data?.length ? `${data.length} chars` : 'empty');
        localStorage.removeItem(key);
    });
    
    // Clear any auth-related localStorage that might be interfering
    const authKeys = Object.keys(localStorage).filter(key => 
        key.includes('firebase') || 
        key.includes('auth') || 
        key.includes('user') ||
        key.includes('session')
    );
    
    authKeys.forEach(key => {
        console.log(`🧹 Clearing auth-related key: ${key}`);
        localStorage.removeItem(key);
    });
    
    console.log('🧹 Guest data leakage cleaned - refresh page to test clean state');
    return 'Guest data cleaned - refresh to test';
};
console.log("Clean guest data with: window.cleanGuestDataLeakage()");

// PROFILE SCENE AUTHENTICATION DEBUGGER
window.debugProfileSceneAuth = function() {
    console.log('🔍 ===== PROFILE SCENE AUTHENTICATION DEBUG =====');
    
    const user = auth.currentUser;
    const profileScene = window.gameInstance?.scene?.getScene('ProfileSceneDOM');
    const authMenuScene = window.gameInstance?.scene?.getScene('AuthenticatedMenuSceneDOM');
    
    console.log('👤 PROFILE SCENE AUTHENTICATION STATE:', {
        authCurrentUser: {
            exists: !!user,
            uid: user?.uid || 'none',
            email: user?.email || 'none',
            emailVerified: user?.emailVerified || false,
            timing: 'checked at ' + Date.now()
        },
        profileScene: {
            exists: !!profileScene,
            active: profileScene ? window.gameInstance.scene.isActive('ProfileSceneDOM') : false,
            dataLoaded: profileScene?.dataLoaded || false,
            currentData: profileScene?.currentData ? 'loaded' : 'not loaded'
        },
        authMenuScene: {
            exists: !!authMenuScene,
            active: authMenuScene ? window.gameInstance.scene.isActive('AuthenticatedMenuSceneDOM') : false
        }
    });
    
    // Test Firebase access directly
    if (user) {
        console.log('🧪 Testing direct Firebase access for user:', user.uid);
        
        // Test userProfiles access
        db.collection("userProfiles").doc(user.uid).get().then(doc => {
            console.log('✅ Direct Firebase userProfiles test:', {
                exists: doc.exists,
                data: doc.exists ? Object.keys(doc.data()) : 'no data'
            });
        }).catch(error => {
            console.error('❌ Direct Firebase userProfiles test FAILED:', error.code, error.message);
        });
        
        // Test company email service
        import('./services/firmAuthService.js').then(module => {
            const { getCompanyEmailStatus } = module;
            getCompanyEmailStatus(user.uid).then(status => {
                console.log('✅ Company email status test:', status);
            }).catch(error => {
                console.error('❌ Company email status test FAILED:', error);
            });
        }).catch(importError => {
            console.error('❌ Could not import firmAuthService:', importError);
        });
    }
    
    return 'Profile scene authentication debug completed';
};
console.log("Debug profile auth with: window.debugProfileSceneAuth()");

// HALL OF FAME ERROR DEBUGGER  
window.debugHallOfFameErrors = function() {
    console.log('🔍 ===== HALL OF FAME ERROR DEBUG =====');
    
    const user = auth.currentUser;
    
    if (!user) {
        console.log('❌ No authenticated user for Hall of Fame access');
        return 'No authenticated user';
    }
    
    console.log('🏆 Testing Hall of Fame data access for user:', user.uid);
    
    // Test direct leaderboard data access
    const testCollections = [
        'pptHeroScores',
        'userProfiles', 
        'userAnalytics',
        'leaderboards',
        'userScores'
    ];
    
    testCollections.forEach(collectionName => {
        console.log(`🧪 Testing ${collectionName} collection access...`);
        
        db.collection(collectionName).limit(1).get().then(snapshot => {
            console.log(`✅ ${collectionName} access SUCCESS:`, {
                size: snapshot.size,
                empty: snapshot.empty
            });
        }).catch(error => {
            console.error(`❌ ${collectionName} access FAILED:`, error.code, error.message);
        });
    });
    
    // Test Hall of Fame DOM
    import('./scenes/HallOfFameDOM.js').then(module => {
        console.log('✅ HallOfFameDOM import successful');
        const HallOfFameDOM = module.default;
        const hallOfFame = new HallOfFameDOM();
        console.log('✅ HallOfFameDOM instance created');
    }).catch(error => {
        console.error('❌ HallOfFameDOM import/creation failed:', error);
    });
    
    return 'Hall of Fame debug completed - check logs above';
};
console.log("Debug Hall of Fame with: window.debugHallOfFameErrors()");

// MAIN MENU BUTTON DEBUGGING TOOL
window.debugMainMenuButton = function() {
    console.log('🔍 ===== MAIN MENU BUTTON DEBUG =====');
    
    const button = document.getElementById("ribbon-mainmenu-btn");
    const currentScene = window.gameInstance?.getActiveScene?.();
    const currentSceneKey = currentScene?.scene?.key || 'none';
    
    console.log('🏠 MAIN MENU BUTTON STATE:', {
        buttonExists: !!button,
        buttonVisible: button ? (button.style.display !== 'none' && button.offsetParent !== null) : false,
        buttonDisabled: button ? button.disabled : 'N/A',
        buttonClickable: button ? !button.disabled && button.offsetParent !== null : false,
        currentSceneKey,
        activeScenes: window.gameInstance?.scene?.scenes?.filter(s => s.scene.isActive())?.map(s => s.scene.key) || []
    });
    
    // Test clicking the button programmatically
    if (button) {
        console.log('🧪 Testing main menu button click...');
        try {
            button.click();
            console.log('✅ Main menu button click successful');
        } catch (error) {
            console.error('❌ Main menu button click failed:', error);
        }
    }
    
    return 'Main menu button debug completed';
};
console.log("Debug main menu button with: window.debugMainMenuButton()");

// SCENE STACKING DEBUGGER
window.debugSceneStacking = function() {
    console.log('🔍 ===== SCENE STACKING DEBUG =====');
    
    if (!window.gameInstance || !window.gameInstance.scene) {
        console.log('❌ No game instance or scene manager available');
        return;
    }
    
    const scenes = window.gameInstance.scene.scenes || [];
    const activeScenes = [];
    const pausedScenes = [];
    const sleepingScenes = [];
    
    scenes.forEach(scene => {
        const key = scene.scene.key;
        const sceneState = {
            key,
            isActive: scene.scene.isActive(),
            isPaused: scene.scene.isPaused(),
            isSleeping: scene.scene.isSleeping(),
            visible: scene.scene.visible,
            alpha: scene.scene.alpha
        };
        
        if (scene.scene.isActive()) {
            activeScenes.push(sceneState);
        } else if (scene.scene.isPaused()) {
            pausedScenes.push(sceneState);
        } else {
            sleepingScenes.push(sceneState);
        }
    });
    
    console.log('🎬 SCENE STACKING ANALYSIS:', {
        totalScenes: scenes.length,
        activeScenes: activeScenes.length,
        pausedScenes: pausedScenes.length,
        sleepingScenes: sleepingScenes.length
    });
    
    if (activeScenes.length > 0) {
        console.log('✅ Active scenes:', activeScenes);
    }
    if (pausedScenes.length > 0) {
        console.log('⏸️ Paused scenes:', pausedScenes);
    }
    if (sleepingScenes.length > 0) {
        console.log('😴 Sleeping scenes:', sleepingScenes.map(s => s.key));
    }
    
    // Check for problematic stacking
    const pptHeroScenes = activeScenes.filter(s => s.key.includes('PPTHero'));
    if (pptHeroScenes.length > 1) {
        console.error('🚨 SCENE STACKING ISSUE: Multiple PPT Hero scenes active!', pptHeroScenes.map(s => s.key));
    }
    
    return 'Scene stacking analysis completed';
};
console.log("Debug scene stacking with: window.debugSceneStacking()");

// COMPREHENSIVE USER SWITCHING DATA ISOLATION SYSTEM
window.cleanUserSwitchData = function() {
    console.log('🔄 ===== COMPREHENSIVE USER SWITCHING CLEANUP =====');
    
    // 1. Clear all user-specific localStorage
    const userDataKeys = Object.keys(localStorage).filter(key => 
        key.includes('pptHero') ||
        key.includes('user') ||
        key.includes('scores') ||
        key.includes('analytics') ||
        key.includes('profile') ||
        key.includes('session') ||
        key.includes('tutorial') ||
        key.includes('leaderboard') ||
        key.includes('firm')
    );
    
    console.log('🧹 Clearing user-specific localStorage keys:', userDataKeys);
    userDataKeys.forEach(key => {
        localStorage.removeItem(key);
    });
    
    // 2. Clear PPTHeroSceneManager verification cache
    if (window.PPTHeroSceneManager && window.PPTHeroSceneManager.clearVerificationCache) {
        window.PPTHeroSceneManager.clearVerificationCache();
        console.log('🧹 PPTHeroSceneManager verification cache cleared');
    }
    
    // 3. Clear any stuck scene states
    if (window.gameInstance && window.gameInstance.scene) {
        const scenesToClean = [
            'PPTHeroGenericScene', 'PPTHeroBainScene', 'ProfileSceneDOM', 
            'AuthenticatedMenuSceneDOM', 'MainMenuSceneDOM'
        ];
        
        scenesToClean.forEach(sceneKey => {
            try {
                const scene = window.gameInstance.scene.getScene(sceneKey);
                if (scene) {
                    if (scene.scene.isActive()) {
                        console.log(`🧹 Cleaning active scene: ${sceneKey}`);
                    }
                    // Reset scene-specific data
                    scene.dataLoaded = false;
                    scene.currentData = null;
                    scene.scoreData = null;
                    scene.roundProgress = null;
                }
            } catch (e) {
                console.log(`🧹 Could not clean scene ${sceneKey}:`, e.message);
            }
        });
    }
    
    // 4. Clear any analytics/scoring system caches
    if (window.analyticsCache) {
        window.analyticsCache.clear();
        console.log('🧹 Analytics cache cleared');
    }
    
    console.log('✅ User switching data isolation cleanup complete');
    return 'User switch cleanup complete - safe for new user login';
};

window.handleUserSwitch = function(oldUser, newUser) {
    console.log('🔄 ===== USER SWITCH DETECTED =====');
    console.log(`🔄 Switching from: ${oldUser?.uid || 'guest'} to: ${newUser?.uid || 'guest'}`);
    
    if (oldUser && newUser && oldUser.uid !== newUser.uid) {
        console.log('🚨 DIFFERENT USER LOGIN - Performing data isolation cleanup');
        window.cleanUserSwitchData();
        
        // Force refresh current scene to load new user's data
        const currentScene = window.sceneManager?.currentSceneKey;
        if (currentScene && currentScene.includes('Authenticated')) {
            console.log('🔄 Refreshing authenticated scene for new user data');
            setTimeout(() => {
                if (window.sceneManager) {
                    window.sceneManager.switchToScene(currentScene);
                }
            }, 500);
        }
    }
};

console.log("Clean user switch data with: window.cleanUserSwitchData()");

// ENHANCED LOGOUT WITH DATA ISOLATION
window.performSecureLogout = async function() {
    console.log('🔒 ===== PERFORMING SECURE LOGOUT WITH DATA ISOLATION =====');
    
    const currentUser = auth.currentUser;
    if (currentUser) {
        console.log('🔒 Logging out user:', currentUser.uid);
        
        // 1. Clean all user-specific data first
        window.cleanUserSwitchData();
        
        // 2. Perform Firebase logout
        try {
            await auth.signOut();
            console.log('✅ Firebase logout successful');
        } catch (error) {
            console.error('❌ Firebase logout error:', error);
        }
        
        // 3. Force transition to DOM/Universal guest area
        setTimeout(() => {
            const useUniversalLanding = localStorage.getItem('pptHeroUseUniversalLanding') === 'true';
            const targetScene = useUniversalLanding ? 'MainMenuSceneUniversal' : 'GuestMenuSceneDOM';
            
            console.log('🔒 Secure logout: Transitioning to guest area:', targetScene);
            if (window.sceneManager) {
                window.sceneManager.switchToScene(targetScene);
            }
        }, 200);
        
        console.log('✅ Secure logout with data isolation complete');
    } else {
        console.log('📊 No user to log out');
    }
};
console.log("Perform secure logout with: window.performSecureLogout()");

// USER SWITCHING TESTING TOOLS
window.testUserSwitching = function() {
    console.log('🧪 ===== USER SWITCHING TEST SUITE =====');
    
    const currentUser = auth.currentUser;
    console.log('🧪 Current user before test:', currentUser?.uid || 'none');
    
    // Test 1: Check for data isolation
    const userDataKeys = Object.keys(localStorage).filter(key => 
        key.includes('pptHero') || key.includes('user') || key.includes('scores')
    );
    console.log('🧪 Current user data in localStorage:', userDataKeys);
    
    // Test 2: Check scene state
    const currentScene = window.sceneManager?.currentSceneKey;
    console.log('🧪 Current scene:', currentScene);
    
    // Test 3: Check Firebase collections access
    if (currentUser) {
        console.log('🧪 Testing Firebase access for user:', currentUser.uid);
        
        const testCollections = ['pptHeroScores', 'userProfiles', 'userAnalytics'];
        testCollections.forEach(collectionName => {
            db.collection(collectionName).where('userId', '==', currentUser.uid).limit(1).get()
                .then(snapshot => {
                    console.log(`✅ ${collectionName} access: SUCCESS (${snapshot.size} docs)`);
                })
                .catch(error => {
                    console.error(`❌ ${collectionName} access: FAILED (${error.code})`);
                });
        });
    }
    
    return 'User switching test completed - check logs above';
};

// SEAMLESS TRANSITION TESTING
window.testSeamlessTransitions = function() {
    console.log('🧪 ===== SEAMLESS TRANSITION TEST =====');
    
    const currentScene = window.sceneManager?.currentSceneKey;
    console.log('🧪 Starting transition test from:', currentScene);
    
    // Test sequence: Profile → Auth Menu → Profile (should be seamless)
    const testSequence = [
        'ProfileSceneDOM',
        'AuthenticatedMenuSceneDOM', 
        'ProfileSceneDOM'
    ];
    
    let currentStep = 0;
    
    const executeStep = () => {
        if (currentStep < testSequence.length) {
            const targetScene = testSequence[currentStep];
            console.log(`🧪 Step ${currentStep + 1}: Transitioning to ${targetScene}`);
            
            if (window.sceneManager) {
                window.sceneManager.switchToScene(targetScene);
            }
            
            currentStep++;
            setTimeout(executeStep, 2000); // 2 second delay between steps
        } else {
            console.log('✅ Seamless transition test sequence completed');
        }
    };
    
    // Start the test after a brief delay
    setTimeout(executeStep, 1000);
    
    return 'Seamless transition test started - will take ~6 seconds';
};

console.log("Test user switching with: window.testUserSwitching()");
console.log("Test seamless transitions with: window.testSeamlessTransitions()");

// DOM SCENE CONSISTENCY CHECKER
window.verifyDOMSceneTransition = function() {
    console.log('🔍 ===== DOM SCENE TRANSITION VERIFICATION =====');
    
    const currentScene = window.sceneManager?.currentSceneKey;
    const featureFlags = {
        useUniversalLanding: localStorage.getItem('pptHeroUseUniversalLanding') === 'true',
        useDOMMenus: localStorage.getItem('pptHeroUseDOMMenus') === 'true',
        useDOMAuthMenu: localStorage.getItem('pptHeroUseDOMAuthMenu') === 'true',
        useDOMProfile: localStorage.getItem('pptHeroUseDOMProfile') === 'true'
    };
    
    console.log('🎬 DOM SCENE CONSISTENCY CHECK:', {
        currentScene,
        featureFlags,
        isInDOMScene: currentScene ? currentScene.includes('DOM') || currentScene.includes('Universal') : false,
        shouldBeInDOMScene: true // User expects all DOM
    });
    
    // Test logout flow
    const user = auth.currentUser;
    if (user) {
        console.log('🧪 Testing logout flow (will perform actual logout in 3 seconds)...');
        console.log('🧪 Expected logout target: GuestMenuSceneDOM or MainMenuSceneUniversal');
        
        setTimeout(() => {
            console.log('🧪 Performing test logout...');
            window.performSecureLogout();
        }, 3000);
    } else {
        console.log('📊 No authenticated user to test logout flow');
    }
    
    return 'DOM scene transition verification started - check logs above';
};

window.forceDOMSceneConsistency = function() {
    console.log('🔧 ===== FORCING DOM SCENE CONSISTENCY =====');
    
    // Force all DOM feature flags
    localStorage.setItem('pptHeroUseDOMMenus', 'true');
    localStorage.setItem('pptHeroUseDOMAuthMenu', 'true');  
    localStorage.setItem('pptHeroUseDOMProfile', 'true');
    localStorage.setItem('pptHeroUseNewAnalytics', 'true');
    localStorage.setItem('pptHeroUseDOMHallOfFame', 'true');
    localStorage.setItem('pptHeroUseUniversalLanding', 'true');
    
    console.log('✅ All DOM feature flags enabled');
    console.log('🔄 Please refresh the page for complete DOM transition');
    
    return 'DOM consistency enforced - refresh page to apply';
};

console.log("Verify DOM transitions with: window.verifyDOMSceneTransition()");  
console.log("Force DOM consistency with: window.forceDOMSceneConsistency()");

// PROFILE SCENE DATA DEBUGGING
window.debugProfileSceneData = function() {
    console.log('🔍 ===== PROFILE SCENE DATA DEBUG =====');
    
    const user = auth.currentUser;
    const profileScene = window.gameInstance?.scene?.getScene('ProfileSceneDOM');
    
    if (!user) {
        console.log('❌ No authenticated user for profile data debug');
        return 'No authenticated user';
    }
    
    console.log('👤 PROFILE DATA DEBUG FOR USER:', {
        uid: user.uid,
        email: user.email,
        displayName: user.displayName,
        emailVerified: user.emailVerified
    });
    
    if (profileScene) {
        console.log('📊 PROFILE SCENE STATE:', {
            sceneExists: true,
            isActive: window.gameInstance.scene.isActive('ProfileSceneDOM'),
            dataLoaded: profileScene.dataLoaded,
            hasCurrentData: !!profileScene.currentData,
            currentDataKeys: profileScene.currentData ? Object.keys(profileScene.currentData) : 'none'
        });
        
        if (profileScene.currentData) {
            console.log('📊 CURRENT DATA STRUCTURE:', {
                profileData: !!profileScene.currentData.profileData,
                pptScores: profileScene.currentData.pptScores?.length || 0,
                pptGamesPlayed: profileScene.currentData.pptGamesPlayed,
                pptBestScore: profileScene.currentData.pptBestScore,
                companyEmailStatus: profileScene.currentData.companyEmailStatus,
                baselinePPT: !!profileScene.currentData.baselinePPT
            });
        }
    } else {
        console.log('❌ ProfileSceneDOM scene not found');
    }
    
    // Test direct Firebase access for user
    console.log('🧪 Testing direct Firebase access...');
    
    db.collection("userProfiles").doc(user.uid).get().then(doc => {
        console.log('✅ userProfiles access:', {
            exists: doc.exists,
            data: doc.exists ? Object.keys(doc.data()) : 'no data'
        });
    }).catch(error => {
        console.error('❌ userProfiles access failed:', error.code, error.message);
    });
    
    return 'Profile scene data debug completed - check logs above';
};

console.log("Debug profile data with: window.debugProfileSceneData()");

// COMPREHENSIVE SCENE ROUTING AUDIT
window.auditAllSceneRouting = function() {
    console.log('🔍 ===== COMPREHENSIVE SCENE ROUTING AUDIT =====');
    
    const patterns = [
        'MainMenuScene"',
        'GuestMenuScene"', 
        'AuthenticatedMenuScene"',
        '"MainMenuScene',
        '"GuestMenuScene',
        '"AuthenticatedMenuScene'
    ];
    
    console.log('🔍 Searching for old scene references...');
    patterns.forEach(pattern => {
        console.log(`🔍 Pattern: ${pattern} - Check browser dev tools Network tab for any remaining references`);
    });
    
    const currentFeatureFlags = {
        useDOMMenus: localStorage.getItem('pptHeroUseDOMMenus'),
        useDOMAuthMenu: localStorage.getItem('pptHeroUseDOMAuthMenu'), 
        useDOMProfile: localStorage.getItem('pptHeroUseDOMProfile'),
        useUniversalLanding: localStorage.getItem('pptHeroUseUniversalLanding')
    };
    
    console.log('📊 CURRENT FEATURE FLAGS:', currentFeatureFlags);
    
    // Check if all flags are set for DOM
    const allDOMEnabled = Object.values(currentFeatureFlags).every(flag => flag === 'true');
    console.log('🏆 ALL DOM FLAGS ENABLED:', allDOMEnabled);
    
    return allDOMEnabled ? 'All DOM flags enabled - fully transitioned' : 'Some DOM flags missing - use window.forceDOMSceneConsistency()';
};

console.log("Audit scene routing with: window.auditAllSceneRouting()");

// COMPLETE DOM TRANSITION TESTER
window.testCompleteFlow = function() {
    console.log('🧪 ===== COMPLETE DOM FLOW TEST =====');
    
    // Force all DOM flags for clean test
    window.forceDOMSceneConsistency();
    
    console.log('🧪 Testing sequence will start in 2 seconds:');
    console.log('1. Profile access test');
    console.log('2. Data loading verification'); 
    console.log('3. Logout flow test');
    console.log('4. DOM scene consistency verification');
    
    setTimeout(() => {
        console.log('🧪 Step 1: Testing profile data...');
        window.debugProfileSceneData();
        
        setTimeout(() => {
            console.log('🧪 Step 2: Testing DOM consistency...');
            window.verifyDOMSceneTransition();
        }, 2000);
    }, 2000);
    
    return 'Complete flow test initiated - check console for results';
};

console.log("🧪 TEST COMPLETE FIXED FLOW: window.testCompleteFlow()");

// PRELOADER CONFIGURATION TEST
window.testPreloaderConfig = function(config = 'current') {
    console.log(`🧪 Testing preloader configuration: ${config}`);
    
    const preloader = document.getElementById('preloader');
    if (!preloader) {
        console.log('No preloader found - already optimized or removed');
        return 'No preloader active';
    }
    
    switch (config) {
        case 'minimal':
            console.log('🔧 Applying minimal executive preloader...');
            const logo = preloader.querySelector('.executive-logo');
            const tagline = preloader.querySelector('.executive-tagline');
            const loader = preloader.querySelector('.minimal-loader');
            const status = preloader.querySelector('.loader-status');
            
            if (logo) logo.textContent = 'DeckOps.ai';
            if (tagline) tagline.style.display = 'none';
            if (loader) loader.style.display = 'none';
            if (status) status.textContent = 'Loading...';
            
            return 'Minimal configuration applied';
            
        case 'professional':
            console.log('🔧 Applying professional executive preloader...');
            // This is the current configuration - already applied
            return 'Professional configuration active';
            
        case 'remove':
            console.log('🔧 Removing preloader immediately...');
            preloader.style.opacity = '0';
            setTimeout(() => preloader.remove(), 300);
            return 'Preloader removed - direct to BootSceneDOM';
            
        case 'fast':
            console.log('🔧 Applying fast transition preloader...');
            preloader.style.transition = 'opacity 0.2s ease-out';
            const loaderBar = preloader.querySelector('#loader-bar');
            if (loaderBar) loaderBar.style.width = '100%';
            const statusText = preloader.querySelector('#loader-text');
            if (statusText) statusText.textContent = 'Ready';
            
            setTimeout(() => {
                if (window.preloader && window.preloader.hide) {
                    window.preloader.hide();
                }
            }, 500);
            
            return 'Fast transition configuration applied';
            
        default:
            return 'Available configs: minimal, professional, remove, fast';
    }
};
console.log("Test preloader configs with: window.testPreloaderConfig('minimal|professional|remove|fast')");

// Update the setupRibbonListeners function in index.js
// Find this function and replace the Main Menu Button handler:
// index.js - Ribbon Button Handlers - FIXED VERSION
function setupRibbonListeners() {
    // Main Menu Button - ENHANCED with debugging for PPT Hero scene stacking issues
    document.getElementById("ribbon-mainmenu-btn")?.addEventListener("click", () => {
      console.log('🏠 Main Menu button clicked - analyzing current state...');
      
      // Debug current scene state
      if (window.gameInstance && window.gameInstance.scene) {
        const activeScenes = [];
        const phaserScenes = window.gameInstance.scene.scenes || [];
        phaserScenes.forEach(scene => {
          if (scene.scene.isActive()) {
            activeScenes.push(scene.scene.key);
          }
        });
        console.log('🏠 Active scenes before cleanup:', activeScenes);
      }
      const scenesToStop = [
        "GameScene", "PPTHeroScene", "PPTHeroGenericScene", "PPTHeroBainScene", "MultiplayerGameScene", 
        "ProfileScene", "ProfileSceneDOM", "BootSceneDOM", 
        "AuthenticatedMenuScene", "AuthenticatedMenuSceneDOM", "AdminConsoleScene", 
        "CreateGameScene", "JoinGameScene", "LobbyScene", "MultiplayerMenuScene", 
        "MultiplayerGameOverScene", "ClassifyScene", "PhilosophyFlowScene"
      ];
      
      // Stop all game scenes with enhanced logging
      let stoppedScenes = [];
      scenesToStop.forEach(sceneName => {
        if (window.gameInstance?.scene?.isActive(sceneName)) {
          try { 
            window.gameInstance.scene.stop(sceneName); 
            stoppedScenes.push(sceneName);
          } catch(e){
            console.error(`🏠 Error stopping scene ${sceneName}:`, e);
          }
        }
      });
      console.log('🏠 Stopped scenes:', stoppedScenes);
      
      // ENHANCED: Determine target scene with user switching awareness
      console.log('🏠 Main Menu: Analyzing authentication state for navigation...');
      
      const user = auth.currentUser;
      const specialAccess = typeof hasSpecialAccess === 'function' ? hasSpecialAccess() : false;
      const isEffectivelyLoggedIn = (user && user.emailVerified) || specialAccess;
      
      console.log('🏠 Main Menu: Authentication status:', {
        userExists: !!user,
        userUID: user?.uid || 'none',
        emailVerified: user?.emailVerified || false,
        specialAccess,
        isEffectivelyLoggedIn
      });
      
      const useUniversalLanding = localStorage.getItem('pptHeroUseUniversalLanding') === 'true';
      const useDOMMenus = localStorage.getItem('pptHeroUseDOMMenus') === 'true';
      const useDOMAuthMenu = localStorage.getItem('pptHeroUseDOMAuthMenu') === 'true';
      let targetScene;
      
      if (isEffectivelyLoggedIn) {
        // Authenticated users (verified email OR Guest+) go to authenticated menu
        targetScene = useDOMAuthMenu ? "AuthenticatedMenuSceneDOM" : "AuthenticatedMenuScene";
        console.log(`Main Menu: Routing authenticated user (verified: ${user?.emailVerified}, Guest+: ${specialAccess}) to: ${targetScene}`);
      } else if (user && !user.emailVerified) {
        // Unverified user goes to appropriate guest interface
        targetScene = useUniversalLanding ? "MainMenuSceneUniversal" : 
                     (useDOMMenus ? "GuestMenuSceneDOM" : "GuestMenuScene");
        console.log(`Main Menu: Routing unverified user to: ${targetScene}`);
      } else {
        // True guest users go to guest interface
        targetScene = useUniversalLanding ? "MainMenuSceneUniversal" : 
                     (useDOMMenus ? "GuestMenuSceneDOM" : "GuestMenuScene");
        console.log(`Main Menu: Routing guest user to: ${targetScene}`);
      }
      
      console.log(`Main Menu button pressed. Transitioning to: ${targetScene}`);
      
      // Simple cleanup before transition
      console.log('🏠 CLEANUP: Removing game-active class...');
      document.body.classList.remove('game-active');
      document.body.classList.add('authenticated-dashboard-active');
      console.log('🏠 CLEANUP: Body classes after cleanup:', document.body.className);
      
      const gc = document.getElementById('game-container');
      if (gc) { 
        gc.style.display = 'none'; 
        gc.style.visibility = 'hidden'; 
        console.log('🏠 CLEANUP: Game container hidden');
      }
      const tr = document.getElementById('top-ribbon');
      if (tr) { 
        tr.style.display = 'none';
        console.log('🏠 CLEANUP: Top ribbon hidden');
      }
      
      // Transition
      console.log('🏠 TRANSITION: Starting transition to', targetScene);
      if (window.sceneManager && window.sceneManager.switchToScene) {
        window.sceneManager.switchToScene(targetScene).then(() => {
          console.log('🏠 TRANSITION: Complete - checking overlay visibility...');
          setTimeout(() => {
            const overlay = document.getElementById('auth-menu-dom-overlay');
            if (overlay) {
              console.log('🏠 OVERLAY CHECK:', {
                exists: true,
                display: overlay.style.display,
                visibility: overlay.style.visibility,
                opacity: overlay.style.opacity,
                zIndex: overlay.style.zIndex,
                hasChildren: overlay.children.length
              });
            } else {
              console.error('🏠 OVERLAY MISSING: auth-menu-dom-overlay not found!');
            }
          }, 500);
        });
      } else if(window.gameInstance?.scene) {
        window.gameInstance.scene.start(targetScene);
      }
    });
  
    // Leaderboard Button - REMOVED (Hidden via CSS)
    // const leaderboardBtn = document.getElementById("ribbon-leaderboard-btn");
    // if (leaderboardBtn) { leaderboardBtn.style.display = 'none'; } // Also force hide just in case
  
    // Analytics Button
    document.getElementById('ribbon-analytics-btn')?.addEventListener('click', async () => {
      const user = auth.currentUser;
      if (user) {
        // Feature flag to use new Performance Rating System
        const useNewPerformanceRating = localStorage.getItem('pptHeroUseNewAnalytics') === 'true';
        
        if (useNewPerformanceRating) {
          console.log('🆕 HTML Ribbon using new Performance Rating System');
          try {
            const { default: PerformanceRatingSystem } = await import('./scenes/ppt-hero/modules/PerformanceRatingSystem.js');
            // Create temporary scene context for ribbon access
            const currentScene = window.game?.scene?.getAt(0) || { cameras: { main: { width: 1200, height: 800 } } };
            const performanceSystem = new PerformanceRatingSystem(currentScene);
            await performanceSystem.showPerformanceOverlay();
          } catch (error) {
            console.error('Error loading new Performance Rating System from ribbon:', error);
            showGeneralMessage('Error loading analytics. Please try again.', 3000, true);
          }
        } else {
          console.log('📊 HTML Ribbon using legacy analytics system');
          try {
            await populateAnalyticsOverlay(user.uid);
            UIController.showOverlay('analytics-overlay');
          } catch (err) {
            console.error("Error preparing analytics:", err);
            showGeneralMessage("Could not load analytics data.", 3000, true);
          }
        }
      } else {
        showGeneralMessage("Please sign in to view analytics.", 3000, true);
      }
    });
  
    // Privacy Settings Button
    document.getElementById("privacy-settings-btn")?.addEventListener("click", () => {
      UIController.showOverlay('privacy-overlay');
    });
    
    // Tutorial Button (PPT Hero Welcome Guide)
    document.getElementById('ribbon-tutorial-btn')?.addEventListener('click', async () => {
      console.log('📚 Ribbon tutorial button clicked');
      
      // Check feature flag
      const tutorialEnabled = localStorage.getItem('pptHeroEnableTutorial') === 'true';
      if (!tutorialEnabled) {
        showGeneralMessage('Welcome tutorial is currently disabled.', 2000, false);
        return;
      }
      
      try {
        // Import and create tutorial service
        const { default: TutorialService } = await import('./services/tutorialService.js');
        const tutorialService = new TutorialService();
        
        // Get current scene context for firm affiliation
        const currentScene = window.game?.scene?.getAt(0);
        const firmAffiliation = currentScene?.userProfile?.firm === 'bain' ? 'Bain & Company' : 'Generic User';
        
        // Show tutorial manually
        tutorialService.showTutorial(currentScene, firmAffiliation);
        
      } catch (error) {
        console.error('Error loading tutorial from ribbon:', error);
        showGeneralMessage('Tutorial temporarily unavailable.', 3000, true);
      }
    });
  
    // Logout Button
    document.getElementById("ribbon-logout-btn")?.addEventListener("click", () => {
      signOutUser().catch(error => {
        console.error("Error during sign out:", error);
        showGeneralMessage("Error signing out.", 3000, true);
      }); // Auth listener handles scene change
    });
  
    // Calibration Reset Button
    document.getElementById('reset-calibration-btn')?.addEventListener('click', async () => {
      const user = auth.currentUser;
      if (!user) { showGeneralMessage("Please sign in to reset calibration.", 3000, true); return; }
      const codeInput = document.getElementById('calibration-code');
      const code = codeInput?.value?.trim();
      if (!code) { showGeneralMessage("Please enter a reset code.", 3000, true); return; }
  
      try {
        const { handleCalibrationReset } = await import("./services/analyticsService.js");
        const result = await handleCalibrationReset(user.uid, code); // Needs implementation
        showGeneralMessage(result.message || 'Processing reset...', 3000, !result.success);
        if (result.success && codeInput) codeInput.value = '';
      } catch (error) {
        console.error("Error resetting calibration:", error);
        showGeneralMessage("Error resetting calibration.", 3000, true);
      }
    });
  }


// --- Listener for Custom 'auth-change' Event ---
window.addEventListener('auth-change', () => {
    console.log(">>> Custom 'auth-change' event received.");
    // Directly call the reusable logic function with current user state
    handleAuthStateChangeLogic(auth.currentUser);
});

// --- Global Error Handler ---
window.addEventListener('error', function(event) {
    // --- MODIFIED TO CATCH THE SPECIFIC FIREBASE ERROR ---
    if (event.message.includes('onAuthStateChanged failed: First argument "nextOrObserver"')) {
        console.error("******** DETECTED THE PERSISTENT onAuthStateChanged ERROR ********");
        console.error("Error Details:", event.message);
        console.error("Origin:", event.filename, "Line:", event.lineno);
        console.error("Full Error Object:", event.error);
        // Optionally show a more specific user message or attempt recovery
        showGeneralMessage("Authentication system error. Please refresh.", 5000, true);
    } else {
        // Handle other global errors as before
        console.error("Global Error:", event.filename, event.lineno, event.message, event.error);
        
        // FIXED: Don't show error notification for minified code errors (they're not user-facing)
        if (!event.filename?.includes('main.') && !event.message?.includes('_0x')) {
        showGeneralMessage("An unexpected error occurred. Trying to recover...", 4000, true);
        }
        
        try { window.fixCanvasDisplay?.(); } catch (recoveryError) { console.error("Recovery attempt failed:", recoveryError); }
    }
});
window.addEventListener('unhandledrejection', function(event) {
    console.error('Unhandled Promise Rejection:', event.reason);
    showGeneralMessage("An background error occurred.", 4000, true);

});
// With this corrected version:
window.addEventListener('auth-change', () => {
    console.log(">>> Custom 'auth-change' event received.");
    // Directly call the reusable logic function with current user state
    handleAuthStateChangeLogic(auth.currentUser);
});

// Export the game instance (optional)
export default window.gameInstance;